var items = {
  "block.minecraft.acacia_button": "アカシアのボタン",
  "block.minecraft.acacia_door": "アカシアのドア",
  "block.minecraft.acacia_fence": "アカシアのフェンス",
  "block.minecraft.acacia_fence_gate": "アカシアのフェンスゲート",
  "block.minecraft.acacia_hanging_sign": "アカシアの吊り看板",
  "block.minecraft.acacia_leaves": "アカシアの葉",
  "block.minecraft.acacia_log": "アカシアの原木",
  "block.minecraft.acacia_planks": "アカシアの板材",
  "block.minecraft.acacia_pressure_plate": "アカシアの感圧板",
  "block.minecraft.acacia_sapling": "アカシアの苗木",
  "block.minecraft.acacia_shelf": "アカシアの棚",
  "block.minecraft.acacia_sign": "アカシアの看板",
  "block.minecraft.acacia_slab": "アカシアのハーフブロック",
  "block.minecraft.acacia_stairs": "アカシアの階段",
  "block.minecraft.acacia_trapdoor": "アカシアのトラップドア",
  "block.minecraft.acacia_wall_hanging_sign": "壁に付けられたアカシアの吊り看板",
  "block.minecraft.acacia_wall_sign": "壁に付けられたアカシアの看板",
  "block.minecraft.acacia_wood": "アカシアの木",
  "block.minecraft.activator_rail": "アクティベーターレール",
  "block.minecraft.air": "空気",
  "block.minecraft.allium": "アリウム",
  "block.minecraft.amethyst_block": "アメジストブロック",
  "block.minecraft.amethyst_cluster": "アメジストの塊",
  "block.minecraft.ancient_debris": "古代の残骸",
  "block.minecraft.andesite": "安山岩",
  "block.minecraft.andesite_slab": "安山岩のハーフブロック",
  "block.minecraft.andesite_stairs": "安山岩の階段",
  "block.minecraft.andesite_wall": "安山岩の塀",
  "block.minecraft.anvil": "金床",
  "block.minecraft.attached_melon_stem": "実がなったスイカの茎",
  "block.minecraft.attached_pumpkin_stem": "実がなったカボチャの茎",
  "block.minecraft.azalea": "ツツジ",
  "block.minecraft.azalea_leaves": "ツツジの葉",
  "block.minecraft.azure_bluet": "ヒナソウ",
  "block.minecraft.bamboo": "竹",
  "block.minecraft.bamboo_block": "竹ブロック",
  "block.minecraft.bamboo_button": "竹のボタン",
  "block.minecraft.bamboo_door": "竹のドア",
  "block.minecraft.bamboo_fence": "竹のフェンス",
  "block.minecraft.bamboo_fence_gate": "竹のフェンスゲート",
  "block.minecraft.bamboo_hanging_sign": "竹の吊り看板",
  "block.minecraft.bamboo_mosaic": "竹細工",
  "block.minecraft.bamboo_mosaic_slab": "竹細工のハーフブロック",
  "block.minecraft.bamboo_mosaic_stairs": "竹細工の階段",
  "block.minecraft.bamboo_planks": "竹の板材",
  "block.minecraft.bamboo_pressure_plate": "竹の感圧板",
  "block.minecraft.bamboo_sapling": "タケノコ",
  "block.minecraft.bamboo_shelf": "竹の棚",
  "block.minecraft.bamboo_sign": "竹の看板",
  "block.minecraft.bamboo_slab": "竹のハーフブロック",
  "block.minecraft.bamboo_stairs": "竹の階段",
  "block.minecraft.bamboo_trapdoor": "竹のトラップドア",
  "block.minecraft.bamboo_wall_hanging_sign": "壁に付けられた竹の吊り看板",
  "block.minecraft.bamboo_wall_sign": "壁に付けられた竹の看板",
  "block.minecraft.banner.base.black": "黒色の下地",
  "block.minecraft.banner.base.blue": "青色の下地",
  "block.minecraft.banner.base.brown": "茶色の下地",
  "block.minecraft.banner.base.cyan": "青緑色の下地",
  "block.minecraft.banner.base.gray": "灰色の下地",
  "block.minecraft.banner.base.green": "緑色の下地",
  "block.minecraft.banner.base.light_blue": "空色の下地",
  "block.minecraft.banner.base.light_gray": "薄灰色の下地",
  "block.minecraft.banner.base.lime": "黄緑色の下地",
  "block.minecraft.banner.base.magenta": "赤紫色の下地",
  "block.minecraft.banner.base.orange": "橙色の下地",
  "block.minecraft.banner.base.pink": "桃色の下地",
  "block.minecraft.banner.base.purple": "紫色の下地",
  "block.minecraft.banner.base.red": "赤色の下地",
  "block.minecraft.banner.base.white": "白色の下地",
  "block.minecraft.banner.base.yellow": "黄色の下地",
  "block.minecraft.banner.border.black": "黒色の縁取り",
  "block.minecraft.banner.border.blue": "青色の縁取り",
  "block.minecraft.banner.border.brown": "茶色の縁取り",
  "block.minecraft.banner.border.cyan": "青緑色の縁取り",
  "block.minecraft.banner.border.gray": "灰色の縁取り",
  "block.minecraft.banner.border.green": "緑色の縁取り",
  "block.minecraft.banner.border.light_blue": "空色の縁取り",
  "block.minecraft.banner.border.light_gray": "薄灰色の縁取り",
  "block.minecraft.banner.border.lime": "黄緑色の縁取り",
  "block.minecraft.banner.border.magenta": "赤紫色の縁取り",
  "block.minecraft.banner.border.orange": "橙色の縁取り",
  "block.minecraft.banner.border.pink": "桃色の縁取り",
  "block.minecraft.banner.border.purple": "紫色の縁取り",
  "block.minecraft.banner.border.red": "赤色の縁取り",
  "block.minecraft.banner.border.white": "白色の縁取り",
  "block.minecraft.banner.border.yellow": "黄色の縁取り",
  "block.minecraft.banner.bricks.black": "黒色のレンガ模様",
  "block.minecraft.banner.bricks.blue": "青色のレンガ模様",
  "block.minecraft.banner.bricks.brown": "茶色のレンガ模様",
  "block.minecraft.banner.bricks.cyan": "青緑色のレンガ模様",
  "block.minecraft.banner.bricks.gray": "灰色のレンガ模様",
  "block.minecraft.banner.bricks.green": "緑色のレンガ模様",
  "block.minecraft.banner.bricks.light_blue": "空色のレンガ模様",
  "block.minecraft.banner.bricks.light_gray": "薄灰色のレンガ模様",
  "block.minecraft.banner.bricks.lime": "黄緑色のレンガ模様",
  "block.minecraft.banner.bricks.magenta": "赤紫色のレンガ模様",
  "block.minecraft.banner.bricks.orange": "橙色のレンガ模様",
  "block.minecraft.banner.bricks.pink": "桃色のレンガ模様",
  "block.minecraft.banner.bricks.purple": "紫色のレンガ模様",
  "block.minecraft.banner.bricks.red": "赤色のレンガ模様",
  "block.minecraft.banner.bricks.white": "白色のレンガ模様",
  "block.minecraft.banner.bricks.yellow": "黄色のレンガ模様",
  "block.minecraft.banner.circle.black": "黒色の円形",
  "block.minecraft.banner.circle.blue": "青色の円形",
  "block.minecraft.banner.circle.brown": "茶色の円形",
  "block.minecraft.banner.circle.cyan": "青緑色の円形",
  "block.minecraft.banner.circle.gray": "灰色の円形",
  "block.minecraft.banner.circle.green": "緑色の円形",
  "block.minecraft.banner.circle.light_blue": "空色の円形",
  "block.minecraft.banner.circle.light_gray": "薄灰色の円形",
  "block.minecraft.banner.circle.lime": "黄緑色の円形",
  "block.minecraft.banner.circle.magenta": "赤紫色の円形",
  "block.minecraft.banner.circle.orange": "橙色の円形",
  "block.minecraft.banner.circle.pink": "桃色の円形",
  "block.minecraft.banner.circle.purple": "紫色の円形",
  "block.minecraft.banner.circle.red": "赤色の円形",
  "block.minecraft.banner.circle.white": "白色の円形",
  "block.minecraft.banner.circle.yellow": "黄色の円形",
  "block.minecraft.banner.creeper.black": "黒色のクリーパー模様",
  "block.minecraft.banner.creeper.blue": "青色のクリーパー模様",
  "block.minecraft.banner.creeper.brown": "茶色のクリーパー模様",
  "block.minecraft.banner.creeper.cyan": "青緑色のクリーパー模様",
  "block.minecraft.banner.creeper.gray": "灰色のクリーパー模様",
  "block.minecraft.banner.creeper.green": "緑色のクリーパー模様",
  "block.minecraft.banner.creeper.light_blue": "空色のクリーパー模様",
  "block.minecraft.banner.creeper.light_gray": "薄灰色のクリーパー模様",
  "block.minecraft.banner.creeper.lime": "黄緑色のクリーパー模様",
  "block.minecraft.banner.creeper.magenta": "赤紫色のクリーパー模様",
  "block.minecraft.banner.creeper.orange": "橙色のクリーパー模様",
  "block.minecraft.banner.creeper.pink": "桃色のクリーパー模様",
  "block.minecraft.banner.creeper.purple": "紫色のクリーパー模様",
  "block.minecraft.banner.creeper.red": "赤色のクリーパー模様",
  "block.minecraft.banner.creeper.white": "白色のクリーパー模様",
  "block.minecraft.banner.creeper.yellow": "黄色のクリーパー模様",
  "block.minecraft.banner.cross.black": "黒色の斜め十字",
  "block.minecraft.banner.cross.blue": "青色の斜め十字",
  "block.minecraft.banner.cross.brown": "茶色の斜め十字",
  "block.minecraft.banner.cross.cyan": "青緑色の斜め十字",
  "block.minecraft.banner.cross.gray": "灰色の斜め十字",
  "block.minecraft.banner.cross.green": "緑色の斜め十字",
  "block.minecraft.banner.cross.light_blue": "空色の斜め十字",
  "block.minecraft.banner.cross.light_gray": "薄灰色の斜め十字",
  "block.minecraft.banner.cross.lime": "黄緑色の斜め十字",
  "block.minecraft.banner.cross.magenta": "赤紫色の斜め十字",
  "block.minecraft.banner.cross.orange": "橙色の斜め十字",
  "block.minecraft.banner.cross.pink": "桃色の斜め十字",
  "block.minecraft.banner.cross.purple": "紫色の斜め十字",
  "block.minecraft.banner.cross.red": "赤色の斜め十字",
  "block.minecraft.banner.cross.white": "白色の斜め十字",
  "block.minecraft.banner.cross.yellow": "黄色の斜め十字",
  "block.minecraft.banner.curly_border.black": "黒色の山形波の縁取り",
  "block.minecraft.banner.curly_border.blue": "青色の山形波の縁取り",
  "block.minecraft.banner.curly_border.brown": "茶色の山形波の縁取り",
  "block.minecraft.banner.curly_border.cyan": "青緑色の山形波の縁取り",
  "block.minecraft.banner.curly_border.gray": "灰色の山形波の縁取り",
  "block.minecraft.banner.curly_border.green": "緑色の山形波の縁取り",
  "block.minecraft.banner.curly_border.light_blue": "空色の山形波の縁取り",
  "block.minecraft.banner.curly_border.light_gray": "薄灰色の山形波の縁取り",
  "block.minecraft.banner.curly_border.lime": "黄緑色の山形波の縁取り",
  "block.minecraft.banner.curly_border.magenta": "赤紫色の山形波の縁取り",
  "block.minecraft.banner.curly_border.orange": "橙色の山形波の縁取り",
  "block.minecraft.banner.curly_border.pink": "桃色の山形波の縁取り",
  "block.minecraft.banner.curly_border.purple": "紫色の山形波の縁取り",
  "block.minecraft.banner.curly_border.red": "赤色の山形波の縁取り",
  "block.minecraft.banner.curly_border.white": "白色の山形波の縁取り",
  "block.minecraft.banner.curly_border.yellow": "黄色の山形波の縁取り",
  "block.minecraft.banner.diagonal_left.black": "左上半に黒色の斜め分割",
  "block.minecraft.banner.diagonal_left.blue": "左上半に青色の斜め分割",
  "block.minecraft.banner.diagonal_left.brown": "左上半に茶色の斜め分割",
  "block.minecraft.banner.diagonal_left.cyan": "左上半に青緑色の斜め分割",
  "block.minecraft.banner.diagonal_left.gray": "左上半に灰色の斜め分割",
  "block.minecraft.banner.diagonal_left.green": "左上半に緑色の斜め分割",
  "block.minecraft.banner.diagonal_left.light_blue": "左上半に空色の斜め分割",
  "block.minecraft.banner.diagonal_left.light_gray": "左上半に薄灰色の斜め分割",
  "block.minecraft.banner.diagonal_left.lime": "左上半に黄緑色の斜め分割",
  "block.minecraft.banner.diagonal_left.magenta": "左上半に赤紫色の斜め分割",
  "block.minecraft.banner.diagonal_left.orange": "左上半に橙色の斜め分割",
  "block.minecraft.banner.diagonal_left.pink": "左上半に桃色の斜め分割",
  "block.minecraft.banner.diagonal_left.purple": "左上半に紫色の斜め分割",
  "block.minecraft.banner.diagonal_left.red": "左上半に赤色の斜め分割",
  "block.minecraft.banner.diagonal_left.white": "左上半に白色の斜め分割",
  "block.minecraft.banner.diagonal_left.yellow": "左上半に黄色の斜め分割",
  "block.minecraft.banner.diagonal_right.black": "右上半に黒色の斜め分割",
  "block.minecraft.banner.diagonal_right.blue": "右上半に青色の斜め分割",
  "block.minecraft.banner.diagonal_right.brown": "右上半に茶色の斜め分割",
  "block.minecraft.banner.diagonal_right.cyan": "右上半に青緑色の斜め分割",
  "block.minecraft.banner.diagonal_right.gray": "右上半に灰色の斜め分割",
  "block.minecraft.banner.diagonal_right.green": "右上半に緑色の斜め分割",
  "block.minecraft.banner.diagonal_right.light_blue": "右上半に空色の斜め分割",
  "block.minecraft.banner.diagonal_right.light_gray": "右上半に薄灰色の斜め分割",
  "block.minecraft.banner.diagonal_right.lime": "右上半に黄緑色の斜め分割",
  "block.minecraft.banner.diagonal_right.magenta": "右上半に赤紫色の斜め分割",
  "block.minecraft.banner.diagonal_right.orange": "右上半に橙色の斜め分割",
  "block.minecraft.banner.diagonal_right.pink": "右上半に桃色の斜め分割",
  "block.minecraft.banner.diagonal_right.purple": "右上半に紫色の斜め分割",
  "block.minecraft.banner.diagonal_right.red": "右上半に赤色の斜め分割",
  "block.minecraft.banner.diagonal_right.white": "右上半に白色の斜め分割",
  "block.minecraft.banner.diagonal_right.yellow": "右上半に黄色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.black": "左下半に黒色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.blue": "左下半に青色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.brown": "左下半に茶色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.cyan": "左下半に青緑色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.gray": "左下半に灰色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.green": "左下半に緑色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.light_blue": "左下半に空色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.light_gray": "左下半に薄灰色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.lime": "左下半に黄緑色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.magenta": "左下半に赤紫色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.orange": "左下半に橙色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.pink": "左下半に桃色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.purple": "左下半に紫色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.red": "左下半に赤色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.white": "左下半に白色の斜め分割",
  "block.minecraft.banner.diagonal_up_left.yellow": "左下半に黄色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.black": "右下半に黒色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.blue": "右下半に青色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.brown": "右下半に茶色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.cyan": "右下半に青緑色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.gray": "右下半に灰色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.green": "右下半に緑色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.light_blue": "右下半に空色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.light_gray": "右下半に薄灰色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.lime": "右下半に黄緑色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.magenta": "右下半に赤紫色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.orange": "右下半に橙色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.pink": "右下半に桃色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.purple": "右下半に紫色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.red": "右下半に赤色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.white": "右下半に白色の斜め分割",
  "block.minecraft.banner.diagonal_up_right.yellow": "右下半に黄色の斜め分割",
  "block.minecraft.banner.flow.black": "黒色の渦巻き模様",
  "block.minecraft.banner.flow.blue": "青色の渦巻き模様",
  "block.minecraft.banner.flow.brown": "茶色の渦巻き模様",
  "block.minecraft.banner.flow.cyan": "青緑色の渦巻き模様",
  "block.minecraft.banner.flow.gray": "灰色の渦巻き模様",
  "block.minecraft.banner.flow.green": "緑色の渦巻き模様",
  "block.minecraft.banner.flow.light_blue": "空色の渦巻き模様",
  "block.minecraft.banner.flow.light_gray": "薄灰色の渦巻き模様",
  "block.minecraft.banner.flow.lime": "黄緑色の渦巻き模様",
  "block.minecraft.banner.flow.magenta": "赤紫色の渦巻き模様",
  "block.minecraft.banner.flow.orange": "橙色の渦巻き模様",
  "block.minecraft.banner.flow.pink": "桃色の渦巻き模様",
  "block.minecraft.banner.flow.purple": "紫色の渦巻き模様",
  "block.minecraft.banner.flow.red": "赤色の渦巻き模様",
  "block.minecraft.banner.flow.white": "白色の渦巻き模様",
  "block.minecraft.banner.flow.yellow": "黄色の渦巻き模様",
  "block.minecraft.banner.flower.black": "黒色の花模様",
  "block.minecraft.banner.flower.blue": "青色の花模様",
  "block.minecraft.banner.flower.brown": "茶色の花模様",
  "block.minecraft.banner.flower.cyan": "青緑色の花模様",
  "block.minecraft.banner.flower.gray": "灰色の花模様",
  "block.minecraft.banner.flower.green": "緑色の花模様",
  "block.minecraft.banner.flower.light_blue": "空色の花模様",
  "block.minecraft.banner.flower.light_gray": "薄灰色の花模様",
  "block.minecraft.banner.flower.lime": "黄緑色の花模様",
  "block.minecraft.banner.flower.magenta": "赤紫色の花模様",
  "block.minecraft.banner.flower.orange": "橙色の花模様",
  "block.minecraft.banner.flower.pink": "桃色の花模様",
  "block.minecraft.banner.flower.purple": "紫色の花模様",
  "block.minecraft.banner.flower.red": "赤色の花模様",
  "block.minecraft.banner.flower.white": "白色の花模様",
  "block.minecraft.banner.flower.yellow": "黄色の花模様",
  "block.minecraft.banner.globe.black": "黒色の地球の模様",
  "block.minecraft.banner.globe.blue": "青色の地球の模様",
  "block.minecraft.banner.globe.brown": "茶色の地球の模様",
  "block.minecraft.banner.globe.cyan": "青緑色の地球の模様",
  "block.minecraft.banner.globe.gray": "灰色の地球の模様",
  "block.minecraft.banner.globe.green": "緑色の地球の模様",
  "block.minecraft.banner.globe.light_blue": "空色の地球の模様",
  "block.minecraft.banner.globe.light_gray": "薄灰色の地球の模様",
  "block.minecraft.banner.globe.lime": "黄緑色の地球の模様",
  "block.minecraft.banner.globe.magenta": "赤紫色の地球の模様",
  "block.minecraft.banner.globe.orange": "橙色の地球の模様",
  "block.minecraft.banner.globe.pink": "桃色の地球の模様",
  "block.minecraft.banner.globe.purple": "紫色の地球の模様",
  "block.minecraft.banner.globe.red": "赤色の地球の模様",
  "block.minecraft.banner.globe.white": "白色の地球の模様",
  "block.minecraft.banner.globe.yellow": "黄色の地球の模様",
  "block.minecraft.banner.gradient.black": "上に黒色のグラデーション",
  "block.minecraft.banner.gradient.blue": "上に青色のグラデーション",
  "block.minecraft.banner.gradient.brown": "上に茶色のグラデーション",
  "block.minecraft.banner.gradient.cyan": "上に青緑色のグラデーション",
  "block.minecraft.banner.gradient.gray": "上に灰色のグラデーション",
  "block.minecraft.banner.gradient.green": "上に緑色のグラデーション",
  "block.minecraft.banner.gradient.light_blue": "上に空色のグラデーション",
  "block.minecraft.banner.gradient.light_gray": "上に薄灰色のグラデーション",
  "block.minecraft.banner.gradient.lime": "上に黄緑色のグラデーション",
  "block.minecraft.banner.gradient.magenta": "上に赤紫色のグラデーション",
  "block.minecraft.banner.gradient.orange": "上に橙色のグラデーション",
  "block.minecraft.banner.gradient.pink": "上に桃色のグラデーション",
  "block.minecraft.banner.gradient.purple": "上に紫色のグラデーション",
  "block.minecraft.banner.gradient.red": "上に赤色のグラデーション",
  "block.minecraft.banner.gradient.white": "上に白色のグラデーション",
  "block.minecraft.banner.gradient.yellow": "上に黄色のグラデーション",
  "block.minecraft.banner.gradient_up.black": "下に黒色のグラデーション",
  "block.minecraft.banner.gradient_up.blue": "下に青色のグラデーション",
  "block.minecraft.banner.gradient_up.brown": "下に茶色のグラデーション",
  "block.minecraft.banner.gradient_up.cyan": "下に青緑色のグラデーション",
  "block.minecraft.banner.gradient_up.gray": "下に灰色のグラデーション",
  "block.minecraft.banner.gradient_up.green": "下に緑色のグラデーション",
  "block.minecraft.banner.gradient_up.light_blue": "下に空色のグラデーション",
  "block.minecraft.banner.gradient_up.light_gray": "下に薄灰色のグラデーション",
  "block.minecraft.banner.gradient_up.lime": "下に黄緑色のグラデーション",
  "block.minecraft.banner.gradient_up.magenta": "下に赤紫色のグラデーション",
  "block.minecraft.banner.gradient_up.orange": "下に橙色のグラデーション",
  "block.minecraft.banner.gradient_up.pink": "下に桃色のグラデーション",
  "block.minecraft.banner.gradient_up.purple": "下に紫色のグラデーション",
  "block.minecraft.banner.gradient_up.red": "下に赤色のグラデーション",
  "block.minecraft.banner.gradient_up.white": "下に白色のグラデーション",
  "block.minecraft.banner.gradient_up.yellow": "下に黄色のグラデーション",
  "block.minecraft.banner.guster.black": "黒色の風巻く者の模様",
  "block.minecraft.banner.guster.blue": "青色の風巻く者の模様",
  "block.minecraft.banner.guster.brown": "茶色の風巻く者の模様",
  "block.minecraft.banner.guster.cyan": "青緑色の風巻く者の模様",
  "block.minecraft.banner.guster.gray": "灰色の風巻く者の模様",
  "block.minecraft.banner.guster.green": "緑色の風巻く者の模様",
  "block.minecraft.banner.guster.light_blue": "空色の風巻く者の模様",
  "block.minecraft.banner.guster.light_gray": "薄灰色の風巻く者の模様",
  "block.minecraft.banner.guster.lime": "黄緑色の風巻く者の模様",
  "block.minecraft.banner.guster.magenta": "赤紫色の風巻く者の模様",
  "block.minecraft.banner.guster.orange": "橙色の風巻く者の模様",
  "block.minecraft.banner.guster.pink": "桃色の風巻く者の模様",
  "block.minecraft.banner.guster.purple": "紫色の風巻く者の模様",
  "block.minecraft.banner.guster.red": "赤色の風巻く者の模様",
  "block.minecraft.banner.guster.white": "白色の風巻く者の模様",
  "block.minecraft.banner.guster.yellow": "黄色の風巻く者の模様",
  "block.minecraft.banner.half_horizontal.black": "上半に黒色の横分割",
  "block.minecraft.banner.half_horizontal.blue": "上半に青色の横分割",
  "block.minecraft.banner.half_horizontal.brown": "上半に茶色の横分割",
  "block.minecraft.banner.half_horizontal.cyan": "上半に青緑色の横分割",
  "block.minecraft.banner.half_horizontal.gray": "上半に灰色の横分割",
  "block.minecraft.banner.half_horizontal.green": "上半に緑色の横分割",
  "block.minecraft.banner.half_horizontal.light_blue": "上半に空色の横分割",
  "block.minecraft.banner.half_horizontal.light_gray": "上半に薄灰色の横分割",
  "block.minecraft.banner.half_horizontal.lime": "上半に黄緑色の横分割",
  "block.minecraft.banner.half_horizontal.magenta": "上半に赤紫色の横分割",
  "block.minecraft.banner.half_horizontal.orange": "上半に橙色の横分割",
  "block.minecraft.banner.half_horizontal.pink": "上半に桃色の横分割",
  "block.minecraft.banner.half_horizontal.purple": "上半に紫色の横分割",
  "block.minecraft.banner.half_horizontal.red": "上半に赤色の横分割",
  "block.minecraft.banner.half_horizontal.white": "上半に白色の横分割",
  "block.minecraft.banner.half_horizontal.yellow": "上半に黄色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.black": "下半に黒色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.blue": "下半に青色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.brown": "下半に茶色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.cyan": "下半に青緑色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.gray": "下半に灰色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.green": "下半に緑色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.light_blue": "下半に空色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.light_gray": "下半に薄灰色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.lime": "下半に黄緑色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.magenta": "下半に赤紫色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.orange": "下半に橙色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.pink": "下半に桃色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.purple": "下半に紫色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.red": "下半に赤色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.white": "下半に白色の横分割",
  "block.minecraft.banner.half_horizontal_bottom.yellow": "下半に黄色の横分割",
  "block.minecraft.banner.half_vertical.black": "左半に黒色の縦分割",
  "block.minecraft.banner.half_vertical.blue": "左半に青色の縦分割",
  "block.minecraft.banner.half_vertical.brown": "左半に茶色の縦分割",
  "block.minecraft.banner.half_vertical.cyan": "左半に青緑色の縦分割",
  "block.minecraft.banner.half_vertical.gray": "左半に灰色の縦分割",
  "block.minecraft.banner.half_vertical.green": "左半に緑色の縦分割",
  "block.minecraft.banner.half_vertical.light_blue": "左半に空色の縦分割",
  "block.minecraft.banner.half_vertical.light_gray": "左半に薄灰色の縦分割",
  "block.minecraft.banner.half_vertical.lime": "左半に黄緑色の縦分割",
  "block.minecraft.banner.half_vertical.magenta": "左半に赤紫色の縦分割",
  "block.minecraft.banner.half_vertical.orange": "左半に橙色の縦分割",
  "block.minecraft.banner.half_vertical.pink": "左半に桃色の縦分割",
  "block.minecraft.banner.half_vertical.purple": "左半に紫色の縦分割",
  "block.minecraft.banner.half_vertical.red": "左半に赤色の縦分割",
  "block.minecraft.banner.half_vertical.white": "左半に白色の縦分割",
  "block.minecraft.banner.half_vertical.yellow": "左半に黄色の縦分割",
  "block.minecraft.banner.half_vertical_right.black": "右半に黒色の縦分割",
  "block.minecraft.banner.half_vertical_right.blue": "右半に青色の縦分割",
  "block.minecraft.banner.half_vertical_right.brown": "右半に茶色の縦分割",
  "block.minecraft.banner.half_vertical_right.cyan": "右半に青緑色の縦分割",
  "block.minecraft.banner.half_vertical_right.gray": "右半に灰色の縦分割",
  "block.minecraft.banner.half_vertical_right.green": "右半に緑色の縦分割",
  "block.minecraft.banner.half_vertical_right.light_blue": "右半に空色の縦分割",
  "block.minecraft.banner.half_vertical_right.light_gray": "右半に薄灰色の縦分割",
  "block.minecraft.banner.half_vertical_right.lime": "右半に黄緑色の縦分割",
  "block.minecraft.banner.half_vertical_right.magenta": "右半に赤紫色の縦分割",
  "block.minecraft.banner.half_vertical_right.orange": "右半に橙色の縦分割",
  "block.minecraft.banner.half_vertical_right.pink": "右半に桃色の縦分割",
  "block.minecraft.banner.half_vertical_right.purple": "右半に紫色の縦分割",
  "block.minecraft.banner.half_vertical_right.red": "右半に赤色の縦分割",
  "block.minecraft.banner.half_vertical_right.white": "右半に白色の縦分割",
  "block.minecraft.banner.half_vertical_right.yellow": "右半に黄色の縦分割",
  "block.minecraft.banner.mojang.black": "黒色の何かの模様",
  "block.minecraft.banner.mojang.blue": "青色の何かの模様",
  "block.minecraft.banner.mojang.brown": "茶色の何かの模様",
  "block.minecraft.banner.mojang.cyan": "青緑色の何かの模様",
  "block.minecraft.banner.mojang.gray": "灰色の何かの模様",
  "block.minecraft.banner.mojang.green": "緑色の何かの模様",
  "block.minecraft.banner.mojang.light_blue": "空色の何かの模様",
  "block.minecraft.banner.mojang.light_gray": "薄灰色の何かの模様",
  "block.minecraft.banner.mojang.lime": "黄緑色の何かの模様",
  "block.minecraft.banner.mojang.magenta": "赤紫色の何かの模様",
  "block.minecraft.banner.mojang.orange": "橙色の何かの模様",
  "block.minecraft.banner.mojang.pink": "桃色の何かの模様",
  "block.minecraft.banner.mojang.purple": "紫色の何かの模様",
  "block.minecraft.banner.mojang.red": "赤色の何かの模様",
  "block.minecraft.banner.mojang.white": "白色の何かの模様",
  "block.minecraft.banner.mojang.yellow": "黄色の何かの模様",
  "block.minecraft.banner.piglin.black": "黒色のブタの鼻の模様",
  "block.minecraft.banner.piglin.blue": "青色のブタの鼻の模様",
  "block.minecraft.banner.piglin.brown": "茶色のブタの鼻の模様",
  "block.minecraft.banner.piglin.cyan": "青緑色のブタの鼻の模様",
  "block.minecraft.banner.piglin.gray": "灰色のブタの鼻の模様",
  "block.minecraft.banner.piglin.green": "緑色のブタの鼻の模様",
  "block.minecraft.banner.piglin.light_blue": "空色のブタの鼻の模様",
  "block.minecraft.banner.piglin.light_gray": "薄灰色のブタの鼻の模様",
  "block.minecraft.banner.piglin.lime": "黄緑色のブタの鼻の模様",
  "block.minecraft.banner.piglin.magenta": "赤紫色のブタの鼻の模様",
  "block.minecraft.banner.piglin.orange": "橙色のブタの鼻の模様",
  "block.minecraft.banner.piglin.pink": "桃色のブタの鼻の模様",
  "block.minecraft.banner.piglin.purple": "紫色のブタの鼻の模様",
  "block.minecraft.banner.piglin.red": "赤色のブタの鼻の模様",
  "block.minecraft.banner.piglin.white": "白色のブタの鼻の模様",
  "block.minecraft.banner.piglin.yellow": "黄色のブタの鼻の模様",
  "block.minecraft.banner.rhombus.black": "黒色の菱形",
  "block.minecraft.banner.rhombus.blue": "青色の菱形",
  "block.minecraft.banner.rhombus.brown": "茶色の菱形",
  "block.minecraft.banner.rhombus.cyan": "青緑色の菱形",
  "block.minecraft.banner.rhombus.gray": "灰色の菱形",
  "block.minecraft.banner.rhombus.green": "緑色の菱形",
  "block.minecraft.banner.rhombus.light_blue": "空色の菱形",
  "block.minecraft.banner.rhombus.light_gray": "薄灰色の菱形",
  "block.minecraft.banner.rhombus.lime": "黄緑色の菱形",
  "block.minecraft.banner.rhombus.magenta": "赤紫色の菱形",
  "block.minecraft.banner.rhombus.orange": "橙色の菱形",
  "block.minecraft.banner.rhombus.pink": "桃色の菱形",
  "block.minecraft.banner.rhombus.purple": "紫色の菱形",
  "block.minecraft.banner.rhombus.red": "赤色の菱形",
  "block.minecraft.banner.rhombus.white": "白色の菱形",
  "block.minecraft.banner.rhombus.yellow": "黄色の菱形",
  "block.minecraft.banner.skull.black": "黒色の骸骨模様",
  "block.minecraft.banner.skull.blue": "青色の骸骨模様",
  "block.minecraft.banner.skull.brown": "茶色の骸骨模様",
  "block.minecraft.banner.skull.cyan": "青緑色の骸骨模様",
  "block.minecraft.banner.skull.gray": "灰色の骸骨模様",
  "block.minecraft.banner.skull.green": "緑色の骸骨模様",
  "block.minecraft.banner.skull.light_blue": "空色の骸骨模様",
  "block.minecraft.banner.skull.light_gray": "薄灰色の骸骨模様",
  "block.minecraft.banner.skull.lime": "黄緑色の骸骨模様",
  "block.minecraft.banner.skull.magenta": "赤紫色の骸骨模様",
  "block.minecraft.banner.skull.orange": "橙色の骸骨模様",
  "block.minecraft.banner.skull.pink": "桃色の骸骨模様",
  "block.minecraft.banner.skull.purple": "紫色の骸骨模様",
  "block.minecraft.banner.skull.red": "赤色の骸骨模様",
  "block.minecraft.banner.skull.white": "白色の骸骨模様",
  "block.minecraft.banner.skull.yellow": "黄色の骸骨模様",
  "block.minecraft.banner.small_stripes.black": "黒色の縦縞",
  "block.minecraft.banner.small_stripes.blue": "青色の縦縞",
  "block.minecraft.banner.small_stripes.brown": "茶色の縦縞",
  "block.minecraft.banner.small_stripes.cyan": "青緑色の縦縞",
  "block.minecraft.banner.small_stripes.gray": "灰色の縦縞",
  "block.minecraft.banner.small_stripes.green": "緑色の縦縞",
  "block.minecraft.banner.small_stripes.light_blue": "空色の縦縞",
  "block.minecraft.banner.small_stripes.light_gray": "薄灰色の縦縞",
  "block.minecraft.banner.small_stripes.lime": "黄緑色の縦縞",
  "block.minecraft.banner.small_stripes.magenta": "赤紫色の縦縞",
  "block.minecraft.banner.small_stripes.orange": "橙色の縦縞",
  "block.minecraft.banner.small_stripes.pink": "桃色の縦縞",
  "block.minecraft.banner.small_stripes.purple": "紫色の縦縞",
  "block.minecraft.banner.small_stripes.red": "赤色の縦縞",
  "block.minecraft.banner.small_stripes.white": "白色の縦縞",
  "block.minecraft.banner.small_stripes.yellow": "黄色の縦縞",
  "block.minecraft.banner.square_bottom_left.black": "左下隅に黒色の方形",
  "block.minecraft.banner.square_bottom_left.blue": "左下隅に青色の方形",
  "block.minecraft.banner.square_bottom_left.brown": "左下隅に茶色の方形",
  "block.minecraft.banner.square_bottom_left.cyan": "左下隅に青緑色の方形",
  "block.minecraft.banner.square_bottom_left.gray": "左下隅に灰色の方形",
  "block.minecraft.banner.square_bottom_left.green": "左下隅に緑色の方形",
  "block.minecraft.banner.square_bottom_left.light_blue": "左下隅に空色の方形",
  "block.minecraft.banner.square_bottom_left.light_gray": "左下隅に薄灰色の方形",
  "block.minecraft.banner.square_bottom_left.lime": "左下隅に黄緑色の方形",
  "block.minecraft.banner.square_bottom_left.magenta": "左下隅に赤紫色の方形",
  "block.minecraft.banner.square_bottom_left.orange": "左下隅に橙色の方形",
  "block.minecraft.banner.square_bottom_left.pink": "左下隅に桃色の方形",
  "block.minecraft.banner.square_bottom_left.purple": "左下隅に紫色の方形",
  "block.minecraft.banner.square_bottom_left.red": "左下隅に赤色の方形",
  "block.minecraft.banner.square_bottom_left.white": "左下隅に白色の方形",
  "block.minecraft.banner.square_bottom_left.yellow": "左下隅に黄色の方形",
  "block.minecraft.banner.square_bottom_right.black": "右下隅に黒色の方形",
  "block.minecraft.banner.square_bottom_right.blue": "右下隅に青色の方形",
  "block.minecraft.banner.square_bottom_right.brown": "右下隅に茶色の方形",
  "block.minecraft.banner.square_bottom_right.cyan": "右下隅に青緑色の方形",
  "block.minecraft.banner.square_bottom_right.gray": "右下隅に灰色の方形",
  "block.minecraft.banner.square_bottom_right.green": "右下隅に緑色の方形",
  "block.minecraft.banner.square_bottom_right.light_blue": "右下隅に空色の方形",
  "block.minecraft.banner.square_bottom_right.light_gray": "右下隅に薄灰色の方形",
  "block.minecraft.banner.square_bottom_right.lime": "右下隅に黄緑色の方形",
  "block.minecraft.banner.square_bottom_right.magenta": "右下隅に赤紫色の方形",
  "block.minecraft.banner.square_bottom_right.orange": "右下隅に橙色の方形",
  "block.minecraft.banner.square_bottom_right.pink": "右下隅に桃色の方形",
  "block.minecraft.banner.square_bottom_right.purple": "右下隅に紫色の方形",
  "block.minecraft.banner.square_bottom_right.red": "右下隅に赤色の方形",
  "block.minecraft.banner.square_bottom_right.white": "右下隅に白色の方形",
  "block.minecraft.banner.square_bottom_right.yellow": "右下隅に黄色の方形",
  "block.minecraft.banner.square_top_left.black": "左上隅に黒色の方形",
  "block.minecraft.banner.square_top_left.blue": "左上隅に青色の方形",
  "block.minecraft.banner.square_top_left.brown": "左上隅に茶色の方形",
  "block.minecraft.banner.square_top_left.cyan": "左上隅に青緑色の方形",
  "block.minecraft.banner.square_top_left.gray": "左上隅に灰色の方形",
  "block.minecraft.banner.square_top_left.green": "左上隅に緑色の方形",
  "block.minecraft.banner.square_top_left.light_blue": "左上隅に空色の方形",
  "block.minecraft.banner.square_top_left.light_gray": "左上隅に薄灰色の方形",
  "block.minecraft.banner.square_top_left.lime": "左上隅に黄緑色の方形",
  "block.minecraft.banner.square_top_left.magenta": "左上隅に赤紫色の方形",
  "block.minecraft.banner.square_top_left.orange": "左上隅に橙色の方形",
  "block.minecraft.banner.square_top_left.pink": "左上隅に桃色の方形",
  "block.minecraft.banner.square_top_left.purple": "左上隅に紫色の方形",
  "block.minecraft.banner.square_top_left.red": "左上隅に赤色の方形",
  "block.minecraft.banner.square_top_left.white": "左上隅に白色の方形",
  "block.minecraft.banner.square_top_left.yellow": "左上隅に黄色の方形",
  "block.minecraft.banner.square_top_right.black": "右上隅に黒色の方形",
  "block.minecraft.banner.square_top_right.blue": "右上隅に青色の方形",
  "block.minecraft.banner.square_top_right.brown": "右上隅に茶色の方形",
  "block.minecraft.banner.square_top_right.cyan": "右上隅に青緑色の方形",
  "block.minecraft.banner.square_top_right.gray": "右上隅に灰色の方形",
  "block.minecraft.banner.square_top_right.green": "右上隅に緑色の方形",
  "block.minecraft.banner.square_top_right.light_blue": "右上隅に空色の方形",
  "block.minecraft.banner.square_top_right.light_gray": "右上隅に薄灰色の方形",
  "block.minecraft.banner.square_top_right.lime": "右上隅に黄緑色の方形",
  "block.minecraft.banner.square_top_right.magenta": "右上隅に赤紫色の方形",
  "block.minecraft.banner.square_top_right.orange": "右上隅に橙色の方形",
  "block.minecraft.banner.square_top_right.pink": "右上隅に桃色の方形",
  "block.minecraft.banner.square_top_right.purple": "右上隅に紫色の方形",
  "block.minecraft.banner.square_top_right.red": "右上隅に赤色の方形",
  "block.minecraft.banner.square_top_right.white": "右上隅に白色の方形",
  "block.minecraft.banner.square_top_right.yellow": "右上隅に黄色の方形",
  "block.minecraft.banner.straight_cross.black": "黒色の十字",
  "block.minecraft.banner.straight_cross.blue": "青色の十字",
  "block.minecraft.banner.straight_cross.brown": "茶色の十字",
  "block.minecraft.banner.straight_cross.cyan": "青緑色の十字",
  "block.minecraft.banner.straight_cross.gray": "灰色の十字",
  "block.minecraft.banner.straight_cross.green": "緑色の十字",
  "block.minecraft.banner.straight_cross.light_blue": "空色の十字",
  "block.minecraft.banner.straight_cross.light_gray": "薄灰色の十字",
  "block.minecraft.banner.straight_cross.lime": "黄緑色の十字",
  "block.minecraft.banner.straight_cross.magenta": "赤紫色の十字",
  "block.minecraft.banner.straight_cross.orange": "橙色の十字",
  "block.minecraft.banner.straight_cross.pink": "桃色の十字",
  "block.minecraft.banner.straight_cross.purple": "紫色の十字",
  "block.minecraft.banner.straight_cross.red": "赤色の十字",
  "block.minecraft.banner.straight_cross.white": "白色の十字",
  "block.minecraft.banner.straight_cross.yellow": "黄色の十字",
  "block.minecraft.banner.stripe_bottom.black": "下端に黒色の横帯",
  "block.minecraft.banner.stripe_bottom.blue": "下端に青色の横帯",
  "block.minecraft.banner.stripe_bottom.brown": "下端に茶色の横帯",
  "block.minecraft.banner.stripe_bottom.cyan": "下端に青緑色の横帯",
  "block.minecraft.banner.stripe_bottom.gray": "下端に灰色の横帯",
  "block.minecraft.banner.stripe_bottom.green": "下端に緑色の横帯",
  "block.minecraft.banner.stripe_bottom.light_blue": "下端に空色の横帯",
  "block.minecraft.banner.stripe_bottom.light_gray": "下端に薄灰色の横帯",
  "block.minecraft.banner.stripe_bottom.lime": "下端に黄緑色の横帯",
  "block.minecraft.banner.stripe_bottom.magenta": "下端に赤紫色の横帯",
  "block.minecraft.banner.stripe_bottom.orange": "下端に橙色の横帯",
  "block.minecraft.banner.stripe_bottom.pink": "下端に桃色の横帯",
  "block.minecraft.banner.stripe_bottom.purple": "下端に紫色の横帯",
  "block.minecraft.banner.stripe_bottom.red": "下端に赤色の横帯",
  "block.minecraft.banner.stripe_bottom.white": "下端に白色の横帯",
  "block.minecraft.banner.stripe_bottom.yellow": "下端に黄色の横帯",
  "block.minecraft.banner.stripe_center.black": "中央に黒色の縦帯",
  "block.minecraft.banner.stripe_center.blue": "中央に青色の縦帯",
  "block.minecraft.banner.stripe_center.brown": "中央に茶色の縦帯",
  "block.minecraft.banner.stripe_center.cyan": "中央に青緑色の縦帯",
  "block.minecraft.banner.stripe_center.gray": "中央に灰色の縦帯",
  "block.minecraft.banner.stripe_center.green": "中央に緑色の縦帯",
  "block.minecraft.banner.stripe_center.light_blue": "中央に空色の縦帯",
  "block.minecraft.banner.stripe_center.light_gray": "中央に薄灰色の縦帯",
  "block.minecraft.banner.stripe_center.lime": "中央に黄緑色の縦帯",
  "block.minecraft.banner.stripe_center.magenta": "中央に赤紫色の縦帯",
  "block.minecraft.banner.stripe_center.orange": "中央に橙色の縦帯",
  "block.minecraft.banner.stripe_center.pink": "中央に桃色の縦帯",
  "block.minecraft.banner.stripe_center.purple": "中央に紫色の縦帯",
  "block.minecraft.banner.stripe_center.red": "中央に赤色の縦帯",
  "block.minecraft.banner.stripe_center.white": "中央に白色の縦帯",
  "block.minecraft.banner.stripe_center.yellow": "中央に黄色の縦帯",
  "block.minecraft.banner.stripe_downleft.black": "左下向きに黒色の斜め帯",
  "block.minecraft.banner.stripe_downleft.blue": "左下向きに青色の斜め帯",
  "block.minecraft.banner.stripe_downleft.brown": "左下向きに茶色の斜め帯",
  "block.minecraft.banner.stripe_downleft.cyan": "左下向きに青緑色の斜め帯",
  "block.minecraft.banner.stripe_downleft.gray": "左下向きに灰色の斜め帯",
  "block.minecraft.banner.stripe_downleft.green": "左下向きに緑色の斜め帯",
  "block.minecraft.banner.stripe_downleft.light_blue": "左下向きに空色の斜め帯",
  "block.minecraft.banner.stripe_downleft.light_gray": "左下向きに薄灰色の斜め帯",
  "block.minecraft.banner.stripe_downleft.lime": "左下向きに黄緑色の斜め帯",
  "block.minecraft.banner.stripe_downleft.magenta": "左下向きに赤紫色の斜め帯",
  "block.minecraft.banner.stripe_downleft.orange": "左下向きに橙色の斜め帯",
  "block.minecraft.banner.stripe_downleft.pink": "左下向きに桃色の斜め帯",
  "block.minecraft.banner.stripe_downleft.purple": "左下向きに紫色の斜め帯",
  "block.minecraft.banner.stripe_downleft.red": "左下向きに赤色の斜め帯",
  "block.minecraft.banner.stripe_downleft.white": "左下向きに白色の斜め帯",
  "block.minecraft.banner.stripe_downleft.yellow": "左下向きに黄色の斜め帯",
  "block.minecraft.banner.stripe_downright.black": "右下向きに黒色の斜め帯",
  "block.minecraft.banner.stripe_downright.blue": "右下向きに青色の斜め帯",
  "block.minecraft.banner.stripe_downright.brown": "右下向きに茶色の斜め帯",
  "block.minecraft.banner.stripe_downright.cyan": "右下向きに青緑色の斜め帯",
  "block.minecraft.banner.stripe_downright.gray": "右下向きに灰色の斜め帯",
  "block.minecraft.banner.stripe_downright.green": "右下向きに緑色の斜め帯",
  "block.minecraft.banner.stripe_downright.light_blue": "右下向きに空色の斜め帯",
  "block.minecraft.banner.stripe_downright.light_gray": "右下向きに薄灰色の斜め帯",
  "block.minecraft.banner.stripe_downright.lime": "右下向きに黄緑色の斜め帯",
  "block.minecraft.banner.stripe_downright.magenta": "右下向きに赤紫色の斜め帯",
  "block.minecraft.banner.stripe_downright.orange": "右下向きに橙色の斜め帯",
  "block.minecraft.banner.stripe_downright.pink": "右下向きに桃色の斜め帯",
  "block.minecraft.banner.stripe_downright.purple": "右下向きに紫色の斜め帯",
  "block.minecraft.banner.stripe_downright.red": "右下向きに赤色の斜め帯",
  "block.minecraft.banner.stripe_downright.white": "右下向きに白色の斜め帯",
  "block.minecraft.banner.stripe_downright.yellow": "右下向きに黄色の斜め帯",
  "block.minecraft.banner.stripe_left.black": "左端に黒色の縦帯",
  "block.minecraft.banner.stripe_left.blue": "左端に青色の縦帯",
  "block.minecraft.banner.stripe_left.brown": "左端に茶色の縦帯",
  "block.minecraft.banner.stripe_left.cyan": "左端に青緑色の縦帯",
  "block.minecraft.banner.stripe_left.gray": "左端に灰色の縦帯",
  "block.minecraft.banner.stripe_left.green": "左端に緑色の縦帯",
  "block.minecraft.banner.stripe_left.light_blue": "左端に空色の縦帯",
  "block.minecraft.banner.stripe_left.light_gray": "左端に薄灰色の縦帯",
  "block.minecraft.banner.stripe_left.lime": "左端に黄緑色の縦帯",
  "block.minecraft.banner.stripe_left.magenta": "左端に赤紫色の縦帯",
  "block.minecraft.banner.stripe_left.orange": "左端に橙色の縦帯",
  "block.minecraft.banner.stripe_left.pink": "左端に桃色の縦帯",
  "block.minecraft.banner.stripe_left.purple": "左端に紫色の縦帯",
  "block.minecraft.banner.stripe_left.red": "左端に赤色の縦帯",
  "block.minecraft.banner.stripe_left.white": "左端に白色の縦帯",
  "block.minecraft.banner.stripe_left.yellow": "左端に黄色の縦帯",
  "block.minecraft.banner.stripe_middle.black": "中央に黒色の横帯",
  "block.minecraft.banner.stripe_middle.blue": "中央に青色の横帯",
  "block.minecraft.banner.stripe_middle.brown": "中央に茶色の横帯",
  "block.minecraft.banner.stripe_middle.cyan": "中央に青緑色の横帯",
  "block.minecraft.banner.stripe_middle.gray": "中央に灰色の横帯",
  "block.minecraft.banner.stripe_middle.green": "中央に緑色の横帯",
  "block.minecraft.banner.stripe_middle.light_blue": "中央に空色の横帯",
  "block.minecraft.banner.stripe_middle.light_gray": "中央に薄灰色の横帯",
  "block.minecraft.banner.stripe_middle.lime": "中央に黄緑色の横帯",
  "block.minecraft.banner.stripe_middle.magenta": "中央に赤紫色の横帯",
  "block.minecraft.banner.stripe_middle.orange": "中央に橙色の横帯",
  "block.minecraft.banner.stripe_middle.pink": "中央に桃色の横帯",
  "block.minecraft.banner.stripe_middle.purple": "中央に紫色の横帯",
  "block.minecraft.banner.stripe_middle.red": "中央に赤色の横帯",
  "block.minecraft.banner.stripe_middle.white": "中央に白色の横帯",
  "block.minecraft.banner.stripe_middle.yellow": "中央に黄色の横帯",
  "block.minecraft.banner.stripe_right.black": "右端に黒色の縦帯",
  "block.minecraft.banner.stripe_right.blue": "右端に青色の縦帯",
  "block.minecraft.banner.stripe_right.brown": "右端に茶色の縦帯",
  "block.minecraft.banner.stripe_right.cyan": "右端に青緑色の縦帯",
  "block.minecraft.banner.stripe_right.gray": "右端に灰色の縦帯",
  "block.minecraft.banner.stripe_right.green": "右端に緑色の縦帯",
  "block.minecraft.banner.stripe_right.light_blue": "右端に空色の縦帯",
  "block.minecraft.banner.stripe_right.light_gray": "右端に薄灰色の縦帯",
  "block.minecraft.banner.stripe_right.lime": "右端に黄緑色の縦帯",
  "block.minecraft.banner.stripe_right.magenta": "右端に赤紫色の縦帯",
  "block.minecraft.banner.stripe_right.orange": "右端に橙色の縦帯",
  "block.minecraft.banner.stripe_right.pink": "右端に桃色の縦帯",
  "block.minecraft.banner.stripe_right.purple": "右端に紫色の縦帯",
  "block.minecraft.banner.stripe_right.red": "右端に赤色の縦帯",
  "block.minecraft.banner.stripe_right.white": "右端に白色の縦帯",
  "block.minecraft.banner.stripe_right.yellow": "右端に黄色の縦帯",
  "block.minecraft.banner.stripe_top.black": "上端に黒色の横帯",
  "block.minecraft.banner.stripe_top.blue": "上端に青色の横帯",
  "block.minecraft.banner.stripe_top.brown": "上端に茶色の横帯",
  "block.minecraft.banner.stripe_top.cyan": "上端に青緑色の横帯",
  "block.minecraft.banner.stripe_top.gray": "上端に灰色の横帯",
  "block.minecraft.banner.stripe_top.green": "上端に緑色の横帯",
  "block.minecraft.banner.stripe_top.light_blue": "上端に空色の横帯",
  "block.minecraft.banner.stripe_top.light_gray": "上端に薄灰色の横帯",
  "block.minecraft.banner.stripe_top.lime": "上端に黄緑色の横帯",
  "block.minecraft.banner.stripe_top.magenta": "上端に赤紫色の横帯",
  "block.minecraft.banner.stripe_top.orange": "上端に橙色の横帯",
  "block.minecraft.banner.stripe_top.pink": "上端に桃色の横帯",
  "block.minecraft.banner.stripe_top.purple": "上端に紫色の横帯",
  "block.minecraft.banner.stripe_top.red": "上端に赤色の横帯",
  "block.minecraft.banner.stripe_top.white": "上端に白色の横帯",
  "block.minecraft.banner.stripe_top.yellow": "上端に黄色の横帯",
  "block.minecraft.banner.triangle_bottom.black": "下半に黒色の上向き山形",
  "block.minecraft.banner.triangle_bottom.blue": "下半に青色の上向き山形",
  "block.minecraft.banner.triangle_bottom.brown": "下半に茶色の上向き山形",
  "block.minecraft.banner.triangle_bottom.cyan": "下半に青緑色の上向き山形",
  "block.minecraft.banner.triangle_bottom.gray": "下半に灰色の上向き山形",
  "block.minecraft.banner.triangle_bottom.green": "下半に緑色の上向き山形",
  "block.minecraft.banner.triangle_bottom.light_blue": "下半に空色の上向き山形",
  "block.minecraft.banner.triangle_bottom.light_gray": "下半に薄灰色の上向き山形",
  "block.minecraft.banner.triangle_bottom.lime": "下半に黄緑色の上向き山形",
  "block.minecraft.banner.triangle_bottom.magenta": "下半に赤紫色の上向き山形",
  "block.minecraft.banner.triangle_bottom.orange": "下半に橙色の上向き山形",
  "block.minecraft.banner.triangle_bottom.pink": "下半に桃色の上向き山形",
  "block.minecraft.banner.triangle_bottom.purple": "下半に紫色の上向き山形",
  "block.minecraft.banner.triangle_bottom.red": "下半に赤色の上向き山形",
  "block.minecraft.banner.triangle_bottom.white": "下半に白色の上向き山形",
  "block.minecraft.banner.triangle_bottom.yellow": "下半に黄色の上向き山形",
  "block.minecraft.banner.triangle_top.black": "上半に黒色の下向き山形",
  "block.minecraft.banner.triangle_top.blue": "上半に青色の下向き山形",
  "block.minecraft.banner.triangle_top.brown": "上半に茶色の下向き山形",
  "block.minecraft.banner.triangle_top.cyan": "上半に青緑色の下向き山形",
  "block.minecraft.banner.triangle_top.gray": "上半に灰色の下向き山形",
  "block.minecraft.banner.triangle_top.green": "上半に緑色の下向き山形",
  "block.minecraft.banner.triangle_top.light_blue": "上半に空色の下向き山形",
  "block.minecraft.banner.triangle_top.light_gray": "上半に薄灰色の下向き山形",
  "block.minecraft.banner.triangle_top.lime": "上半に黄緑色の下向き山形",
  "block.minecraft.banner.triangle_top.magenta": "上半に赤紫色の下向き山形",
  "block.minecraft.banner.triangle_top.orange": "上半に橙色の下向き山形",
  "block.minecraft.banner.triangle_top.pink": "上半に桃色の下向き山形",
  "block.minecraft.banner.triangle_top.purple": "上半に紫色の下向き山形",
  "block.minecraft.banner.triangle_top.red": "上半に赤色の下向き山形",
  "block.minecraft.banner.triangle_top.white": "上半に白色の下向き山形",
  "block.minecraft.banner.triangle_top.yellow": "上半に黄色の下向き山形",
  "block.minecraft.banner.triangles_bottom.black": "下端に黒色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.blue": "下端に青色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.brown": "下端に茶色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.cyan": "下端に青緑色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.gray": "下端に灰色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.green": "下端に緑色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.light_blue": "下端に空色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.light_gray": "下端に薄灰色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.lime": "下端に黄緑色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.magenta": "下端に赤紫色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.orange": "下端に橙色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.pink": "下端に桃色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.purple": "下端に紫色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.red": "下端に赤色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.white": "下端に白色の上向き山形波",
  "block.minecraft.banner.triangles_bottom.yellow": "下端に黄色の上向き山形波",
  "block.minecraft.banner.triangles_top.black": "上端に黒色の下向き山形波",
  "block.minecraft.banner.triangles_top.blue": "上端に青色の下向き山形波",
  "block.minecraft.banner.triangles_top.brown": "上端に茶色の下向き山形波",
  "block.minecraft.banner.triangles_top.cyan": "上端に青緑色の下向き山形波",
  "block.minecraft.banner.triangles_top.gray": "上端に灰色の下向き山形波",
  "block.minecraft.banner.triangles_top.green": "上端に緑色の下向き山形波",
  "block.minecraft.banner.triangles_top.light_blue": "上端に空色の下向き山形波",
  "block.minecraft.banner.triangles_top.light_gray": "上端に薄灰色の下向き山形波",
  "block.minecraft.banner.triangles_top.lime": "上端に黄緑色の下向き山形波",
  "block.minecraft.banner.triangles_top.magenta": "上端に赤紫色の下向き山形波",
  "block.minecraft.banner.triangles_top.orange": "上端に橙色の下向き山形波",
  "block.minecraft.banner.triangles_top.pink": "上端に桃色の下向き山形波",
  "block.minecraft.banner.triangles_top.purple": "上端に紫色の下向き山形波",
  "block.minecraft.banner.triangles_top.red": "上端に赤色の下向き山形波",
  "block.minecraft.banner.triangles_top.white": "上端に白色の下向き山形波",
  "block.minecraft.banner.triangles_top.yellow": "上端に黄色の下向き山形波",
  "block.minecraft.barrel": "樽",
  "block.minecraft.barrier": "バリアブロック",
  "block.minecraft.basalt": "玄武岩",
  "block.minecraft.beacon": "ビーコン",
  "block.minecraft.beacon.primary": "主効果",
  "block.minecraft.beacon.secondary": "副効果",
  "block.minecraft.bed.no_sleep": "夜もしくは雷雨のときのみ寝ることができます",
  "block.minecraft.bed.not_safe": "モンスターが近くにいるため寝ることができません",
  "block.minecraft.bed.obstructed": "このベッドは塞がれています",
  "block.minecraft.bed.occupied": "このベッドは既に使われています",
  "block.minecraft.bed.too_far_away": "ベッドから離れ過ぎているため寝ることができません",
  "block.minecraft.bedrock": "岩盤",
  "block.minecraft.bee_nest": "ミツバチの巣",
  "block.minecraft.beehive": "養蜂箱",
  "block.minecraft.beetroots": "ビートルート",
  "block.minecraft.bell": "鐘",
  "block.minecraft.big_dripleaf": "大きなドリップリーフ",
  "block.minecraft.big_dripleaf_stem": "大きなドリップリーフの茎",
  "block.minecraft.birch_button": "シラカバのボタン",
  "block.minecraft.birch_door": "シラカバのドア",
  "block.minecraft.birch_fence": "シラカバのフェンス",
  "block.minecraft.birch_fence_gate": "シラカバのフェンスゲート",
  "block.minecraft.birch_hanging_sign": "シラカバの吊り看板",
  "block.minecraft.birch_leaves": "シラカバの葉",
  "block.minecraft.birch_log": "シラカバの原木",
  "block.minecraft.birch_planks": "シラカバの板材",
  "block.minecraft.birch_pressure_plate": "シラカバの感圧板",
  "block.minecraft.birch_sapling": "シラカバの苗木",
  "block.minecraft.birch_shelf": "シラカバの棚",
  "block.minecraft.birch_sign": "シラカバの看板",
  "block.minecraft.birch_slab": "シラカバのハーフブロック",
  "block.minecraft.birch_stairs": "シラカバの階段",
  "block.minecraft.birch_trapdoor": "シラカバのトラップドア",
  "block.minecraft.birch_wall_hanging_sign": "壁に付けられたシラカバの吊り看板",
  "block.minecraft.birch_wall_sign": "壁に付けられたシラカバの看板",
  "block.minecraft.birch_wood": "シラカバの木",
  "block.minecraft.black_banner": "黒色の旗",
  "block.minecraft.black_bed": "黒色のベッド",
  "block.minecraft.black_candle": "黒色のろうそく",
  "block.minecraft.black_candle_cake": "黒色のろうそくが立てられたケーキ",
  "block.minecraft.black_carpet": "黒色のカーペット",
  "block.minecraft.black_concrete": "黒色のコンクリート",
  "block.minecraft.black_concrete_powder": "黒色のコンクリートパウダー",
  "block.minecraft.black_glazed_terracotta": "黒色の彩釉テラコッタ",
  "block.minecraft.black_shulker_box": "黒色のシュルカーボックス",
  "block.minecraft.black_stained_glass": "黒色の色付きガラス",
  "block.minecraft.black_stained_glass_pane": "黒色の色付きガラス板",
  "block.minecraft.black_terracotta": "黒色のテラコッタ",
  "block.minecraft.black_wool": "黒色の羊毛",
  "block.minecraft.blackstone": "ブラックストーン",
  "block.minecraft.blackstone_slab": "ブラックストーンのハーフブロック",
  "block.minecraft.blackstone_stairs": "ブラックストーンの階段",
  "block.minecraft.blackstone_wall": "ブラックストーンの塀",
  "block.minecraft.blast_furnace": "溶鉱炉",
  "block.minecraft.blue_banner": "青色の旗",
  "block.minecraft.blue_bed": "青色のベッド",
  "block.minecraft.blue_candle": "青色のろうそく",
  "block.minecraft.blue_candle_cake": "青色のろうそくが立てられたケーキ",
  "block.minecraft.blue_carpet": "青色のカーペット",
  "block.minecraft.blue_concrete": "青色のコンクリート",
  "block.minecraft.blue_concrete_powder": "青色のコンクリートパウダー",
  "block.minecraft.blue_glazed_terracotta": "青色の彩釉テラコッタ",
  "block.minecraft.blue_ice": "青氷",
  "block.minecraft.blue_orchid": "ヒスイラン",
  "block.minecraft.blue_shulker_box": "青色のシュルカーボックス",
  "block.minecraft.blue_stained_glass": "青色の色付きガラス",
  "block.minecraft.blue_stained_glass_pane": "青色の色付きガラス板",
  "block.minecraft.blue_terracotta": "青色のテラコッタ",
  "block.minecraft.blue_wool": "青色の羊毛",
  "block.minecraft.bone_block": "骨ブロック",
  "block.minecraft.bookshelf": "本棚",
  "block.minecraft.brain_coral": "ノウサンゴ",
  "block.minecraft.brain_coral_block": "ノウサンゴブロック",
  "block.minecraft.brain_coral_fan": "ノウウチワサンゴ",
  "block.minecraft.brain_coral_wall_fan": "壁付きのノウウチワサンゴ",
  "block.minecraft.brewing_stand": "醸造台",
  "block.minecraft.brick_slab": "レンガのハーフブロック",
  "block.minecraft.brick_stairs": "レンガの階段",
  "block.minecraft.brick_wall": "レンガの塀",
  "block.minecraft.bricks": "レンガ",
  "block.minecraft.brown_banner": "茶色の旗",
  "block.minecraft.brown_bed": "茶色のベッド",
  "block.minecraft.brown_candle": "茶色のろうそく",
  "block.minecraft.brown_candle_cake": "茶色のろうそくが立てられたケーキ",
  "block.minecraft.brown_carpet": "茶色のカーペット",
  "block.minecraft.brown_concrete": "茶色のコンクリート",
  "block.minecraft.brown_concrete_powder": "茶色のコンクリートパウダー",
  "block.minecraft.brown_glazed_terracotta": "茶色の彩釉テラコッタ",
  "block.minecraft.brown_mushroom": "茶色のキノコ",
  "block.minecraft.brown_mushroom_block": "茶色のキノコブロック",
  "block.minecraft.brown_shulker_box": "茶色のシュルカーボックス",
  "block.minecraft.brown_stained_glass": "茶色の色付きガラス",
  "block.minecraft.brown_stained_glass_pane": "茶色の色付きガラス板",
  "block.minecraft.brown_terracotta": "茶色のテラコッタ",
  "block.minecraft.brown_wool": "茶色の羊毛",
  "block.minecraft.bubble_column": "気泡柱",
  "block.minecraft.bubble_coral": "ミズタマサンゴ",
  "block.minecraft.bubble_coral_block": "ミズタマサンゴブロック",
  "block.minecraft.bubble_coral_fan": "ミズタマウチワサンゴ",
  "block.minecraft.bubble_coral_wall_fan": "壁付きのミズタマウチワサンゴ",
  "block.minecraft.budding_amethyst": "芽生えたアメジスト",
  "block.minecraft.bush": "茂み",
  "block.minecraft.cactus": "サボテン",
  "block.minecraft.cactus_flower": "サボテンの花",
  "block.minecraft.cake": "ケーキ",
  "block.minecraft.calcite": "方解石",
  "block.minecraft.calibrated_sculk_sensor": "調律されたスカルクセンサー",
  "block.minecraft.campfire": "焚き火",
  "block.minecraft.candle": "ろうそく",
  "block.minecraft.candle_cake": "ろうそくが立てられたケーキ",
  "block.minecraft.carrots": "ニンジン",
  "block.minecraft.cartography_table": "製図台",
  "block.minecraft.carved_pumpkin": "くり抜かれたカボチャ",
  "block.minecraft.cauldron": "大釜",
  "block.minecraft.cave_air": "洞窟の空気",
  "block.minecraft.cave_vines": "洞窟のツタ",
  "block.minecraft.cave_vines_plant": "洞窟のツタのつる",
  "block.minecraft.chain": "鉄の鎖",
  "block.minecraft.chain_command_block": "チェーンコマンドブロック",
  "block.minecraft.cherry_button": "サクラのボタン",
  "block.minecraft.cherry_door": "サクラのドア",
  "block.minecraft.cherry_fence": "サクラのフェンス",
  "block.minecraft.cherry_fence_gate": "サクラのフェンスゲート",
  "block.minecraft.cherry_hanging_sign": "サクラの吊り看板",
  "block.minecraft.cherry_leaves": "サクラの葉",
  "block.minecraft.cherry_log": "サクラの原木",
  "block.minecraft.cherry_planks": "サクラの板材",
  "block.minecraft.cherry_pressure_plate": "サクラの感圧板",
  "block.minecraft.cherry_sapling": "サクラの苗木",
  "block.minecraft.cherry_shelf": "サクラの棚",
  "block.minecraft.cherry_sign": "サクラの看板",
  "block.minecraft.cherry_slab": "サクラのハーフブロック",
  "block.minecraft.cherry_stairs": "サクラの階段",
  "block.minecraft.cherry_trapdoor": "サクラのトラップドア",
  "block.minecraft.cherry_wall_hanging_sign": "壁に付けられたサクラの吊り看板",
  "block.minecraft.cherry_wall_sign": "壁に付けられたサクラの看板",
  "block.minecraft.cherry_wood": "サクラの木",
  "block.minecraft.chest": "チェスト",
  "block.minecraft.chipped_anvil": "欠けた金床",
  "block.minecraft.chiseled_bookshelf": "模様入りの本棚",
  "block.minecraft.chiseled_copper": "模様入りの銅",
  "block.minecraft.chiseled_deepslate": "模様入りの深層岩",
  "block.minecraft.chiseled_nether_bricks": "模様入りのネザーレンガ",
  "block.minecraft.chiseled_polished_blackstone": "模様入りの磨かれたブラックストーン",
  "block.minecraft.chiseled_quartz_block": "模様入りのクォーツブロック",
  "block.minecraft.chiseled_red_sandstone": "模様入りの赤い砂岩",
  "block.minecraft.chiseled_resin_bricks": "模様入りの樹脂レンガ",
  "block.minecraft.chiseled_sandstone": "模様入りの砂岩",
  "block.minecraft.chiseled_stone_bricks": "模様入りの石レンガ",
  "block.minecraft.chiseled_tuff": "模様入りの凝灰岩",
  "block.minecraft.chiseled_tuff_bricks": "模様入りの凝灰岩レンガ",
  "block.minecraft.chorus_flower": "コーラスフラワー",
  "block.minecraft.chorus_plant": "コーラスプラント",
  "block.minecraft.clay": "粘土",
  "block.minecraft.closed_eyeblossom": "閉じたヒトミソウ",
  "block.minecraft.coal_block": "石炭ブロック",
  "block.minecraft.coal_ore": "石炭鉱石",
  "block.minecraft.coarse_dirt": "粗い土",
  "block.minecraft.cobbled_deepslate": "深層岩の丸石",
  "block.minecraft.cobbled_deepslate_slab": "深層岩の丸石のハーフブロック",
  "block.minecraft.cobbled_deepslate_stairs": "深層岩の丸石の階段",
  "block.minecraft.cobbled_deepslate_wall": "深層岩の丸石の塀",
  "block.minecraft.cobblestone": "丸石",
  "block.minecraft.cobblestone_slab": "丸石のハーフブロック",
  "block.minecraft.cobblestone_stairs": "丸石の階段",
  "block.minecraft.cobblestone_wall": "丸石の塀",
  "block.minecraft.cobweb": "クモの巣",
  "block.minecraft.cocoa": "カカオの実",
  "block.minecraft.command_block": "コマンドブロック",
  "block.minecraft.comparator": "レッドストーンコンパレーター",
  "block.minecraft.composter": "コンポスター",
  "block.minecraft.conduit": "コンジット",
  "block.minecraft.copper_bars": "銅格子",
  "block.minecraft.copper_block": "銅ブロック",
  "block.minecraft.copper_bulb": "銅の電球",
  "block.minecraft.copper_chain": "銅の鎖",
  "block.minecraft.copper_chest": "銅のチェスト",
  "block.minecraft.copper_door": "銅のドア",
  "block.minecraft.copper_golem_statue": "カッパーゴーレムの像",
  "block.minecraft.copper_grate": "銅の金網",
  "block.minecraft.copper_lantern": "銅のランタン",
  "block.minecraft.copper_ore": "銅鉱石",
  "block.minecraft.copper_torch": "銅の松明",
  "block.minecraft.copper_trapdoor": "銅のトラップドア",
  "block.minecraft.copper_wall_torch": "壁に付けられた銅の松明",
  "block.minecraft.cornflower": "ヤグルマギク",
  "block.minecraft.cracked_deepslate_bricks": "ひび割れた深層岩レンガ",
  "block.minecraft.cracked_deepslate_tiles": "ひび割れた深層岩タイル",
  "block.minecraft.cracked_nether_bricks": "ひび割れたネザーレンガ",
  "block.minecraft.cracked_polished_blackstone_bricks": "ひび割れた磨かれたブラックストーンレンガ",
  "block.minecraft.cracked_stone_bricks": "ひび割れた石レンガ",
  "block.minecraft.crafter": "自動作業台",
  "block.minecraft.crafting_table": "作業台",
  "block.minecraft.creaking_heart": "クリーキングの心臓",
  "block.minecraft.creeper_head": "クリーパーの頭",
  "block.minecraft.creeper_wall_head": "壁に付けられたクリーパーの頭",
  "block.minecraft.crimson_button": "真紅のボタン",
  "block.minecraft.crimson_door": "真紅のドア",
  "block.minecraft.crimson_fence": "真紅のフェンス",
  "block.minecraft.crimson_fence_gate": "真紅のフェンスゲート",
  "block.minecraft.crimson_fungus": "真紅のキノコ",
  "block.minecraft.crimson_hanging_sign": "真紅の吊り看板",
  "block.minecraft.crimson_hyphae": "真紅の菌糸",
  "block.minecraft.crimson_nylium": "真紅のナイリウム",
  "block.minecraft.crimson_planks": "真紅の板材",
  "block.minecraft.crimson_pressure_plate": "真紅の感圧板",
  "block.minecraft.crimson_roots": "真紅の根",
  "block.minecraft.crimson_shelf": "真紅の棚",
  "block.minecraft.crimson_sign": "真紅の看板",
  "block.minecraft.crimson_slab": "真紅のハーフブロック",
  "block.minecraft.crimson_stairs": "真紅の階段",
  "block.minecraft.crimson_stem": "真紅の幹",
  "block.minecraft.crimson_trapdoor": "真紅のトラップドア",
  "block.minecraft.crimson_wall_hanging_sign": "壁に付けられた真紅の吊り看板",
  "block.minecraft.crimson_wall_sign": "壁に付けられた真紅の看板",
  "block.minecraft.crying_obsidian": "泣く黒曜石",
  "block.minecraft.cut_copper": "切り込み入りの銅",
  "block.minecraft.cut_copper_slab": "切り込み入りの銅のハーフブロック",
  "block.minecraft.cut_copper_stairs": "切り込み入りの銅の階段",
  "block.minecraft.cut_red_sandstone": "研がれた赤い砂岩",
  "block.minecraft.cut_red_sandstone_slab": "研がれた赤い砂岩のハーフブロック",
  "block.minecraft.cut_sandstone": "研がれた砂岩",
  "block.minecraft.cut_sandstone_slab": "研がれた砂岩のハーフブロック",
  "block.minecraft.cyan_banner": "青緑色の旗",
  "block.minecraft.cyan_bed": "青緑色のベッド",
  "block.minecraft.cyan_candle": "青緑色のろうそく",
  "block.minecraft.cyan_candle_cake": "青緑色のろうそくが立てられたケーキ",
  "block.minecraft.cyan_carpet": "青緑色のカーペット",
  "block.minecraft.cyan_concrete": "青緑色のコンクリート",
  "block.minecraft.cyan_concrete_powder": "青緑色のコンクリートパウダー",
  "block.minecraft.cyan_glazed_terracotta": "青緑色の彩釉テラコッタ",
  "block.minecraft.cyan_shulker_box": "青緑色のシュルカーボックス",
  "block.minecraft.cyan_stained_glass": "青緑色の色付きガラス",
  "block.minecraft.cyan_stained_glass_pane": "青緑色の色付きガラス板",
  "block.minecraft.cyan_terracotta": "青緑色のテラコッタ",
  "block.minecraft.cyan_wool": "青緑色の羊毛",
  "block.minecraft.damaged_anvil": "壊れかけの金床",
  "block.minecraft.dandelion": "タンポポ",
  "block.minecraft.dark_oak_button": "ダークオークのボタン",
  "block.minecraft.dark_oak_door": "ダークオークのドア",
  "block.minecraft.dark_oak_fence": "ダークオークのフェンス",
  "block.minecraft.dark_oak_fence_gate": "ダークオークのフェンスゲート",
  "block.minecraft.dark_oak_hanging_sign": "ダークオークの吊り看板",
  "block.minecraft.dark_oak_leaves": "ダークオークの葉",
  "block.minecraft.dark_oak_log": "ダークオークの原木",
  "block.minecraft.dark_oak_planks": "ダークオークの板材",
  "block.minecraft.dark_oak_pressure_plate": "ダークオークの感圧板",
  "block.minecraft.dark_oak_sapling": "ダークオークの苗木",
  "block.minecraft.dark_oak_shelf": "ダークオークの棚",
  "block.minecraft.dark_oak_sign": "ダークオークの看板",
  "block.minecraft.dark_oak_slab": "ダークオークのハーフブロック",
  "block.minecraft.dark_oak_stairs": "ダークオークの階段",
  "block.minecraft.dark_oak_trapdoor": "ダークオークのトラップドア",
  "block.minecraft.dark_oak_wall_hanging_sign": "壁に付けられたダークオークの吊り看板",
  "block.minecraft.dark_oak_wall_sign": "壁に付けられたダークオークの看板",
  "block.minecraft.dark_oak_wood": "ダークオークの木",
  "block.minecraft.dark_prismarine": "ダークプリズマリン",
  "block.minecraft.dark_prismarine_slab": "ダークプリズマリンのハーフブロック",
  "block.minecraft.dark_prismarine_stairs": "ダークプリズマリンの階段",
  "block.minecraft.daylight_detector": "日照センサー",
  "block.minecraft.dead_brain_coral": "死んだノウサンゴ",
  "block.minecraft.dead_brain_coral_block": "死んだノウサンゴブロック",
  "block.minecraft.dead_brain_coral_fan": "死んだノウウチワサンゴ",
  "block.minecraft.dead_brain_coral_wall_fan": "壁付きの死んだノウウチワサンゴ",
  "block.minecraft.dead_bubble_coral": "死んだミズタマサンゴ",
  "block.minecraft.dead_bubble_coral_block": "死んだミズタマサンゴブロック",
  "block.minecraft.dead_bubble_coral_fan": "死んだミズタマウチワサンゴ",
  "block.minecraft.dead_bubble_coral_wall_fan": "壁付きの死んだミズタマウチワサンゴ",
  "block.minecraft.dead_bush": "枯れ木",
  "block.minecraft.dead_fire_coral": "死んだミレポラサンゴ",
  "block.minecraft.dead_fire_coral_block": "死んだミレポラサンゴブロック",
  "block.minecraft.dead_fire_coral_fan": "死んだミレポラウチワサンゴ",
  "block.minecraft.dead_fire_coral_wall_fan": "壁付きの死んだミレポラウチワサンゴ",
  "block.minecraft.dead_horn_coral": "死んだシカツノサンゴ",
  "block.minecraft.dead_horn_coral_block": "死んだシカツノサンゴブロック",
  "block.minecraft.dead_horn_coral_fan": "死んだシカツノウチワサンゴ",
  "block.minecraft.dead_horn_coral_wall_fan": "壁付きの死んだシカツノウチワサンゴ",
  "block.minecraft.dead_tube_coral": "死んだクダサンゴ",
  "block.minecraft.dead_tube_coral_block": "死んだクダサンゴブロック",
  "block.minecraft.dead_tube_coral_fan": "死んだクダウチワサンゴ",
  "block.minecraft.dead_tube_coral_wall_fan": "壁付きの死んだクダウチワサンゴ",
  "block.minecraft.decorated_pot": "飾り壺",
  "block.minecraft.deepslate": "深層岩",
  "block.minecraft.deepslate_brick_slab": "深層岩レンガのハーフブロック",
  "block.minecraft.deepslate_brick_stairs": "深層岩レンガの階段",
  "block.minecraft.deepslate_brick_wall": "深層岩レンガの塀",
  "block.minecraft.deepslate_bricks": "深層岩レンガ",
  "block.minecraft.deepslate_coal_ore": "深層石炭鉱石",
  "block.minecraft.deepslate_copper_ore": "深層銅鉱石",
  "block.minecraft.deepslate_diamond_ore": "深層ダイヤモンド鉱石",
  "block.minecraft.deepslate_emerald_ore": "深層エメラルド鉱石",
  "block.minecraft.deepslate_gold_ore": "深層金鉱石",
  "block.minecraft.deepslate_iron_ore": "深層鉄鉱石",
  "block.minecraft.deepslate_lapis_ore": "深層ラピスラズリ鉱石",
  "block.minecraft.deepslate_redstone_ore": "深層レッドストーン鉱石",
  "block.minecraft.deepslate_tile_slab": "深層岩タイルのハーフブロック",
  "block.minecraft.deepslate_tile_stairs": "深層岩タイルの階段",
  "block.minecraft.deepslate_tile_wall": "深層岩タイルの塀",
  "block.minecraft.deepslate_tiles": "深層岩タイル",
  "block.minecraft.detector_rail": "ディテクターレール",
  "block.minecraft.diamond_block": "ダイヤモンドブロック",
  "block.minecraft.diamond_ore": "ダイヤモンド鉱石",
  "block.minecraft.diorite": "閃緑岩",
  "block.minecraft.diorite_slab": "閃緑岩のハーフブロック",
  "block.minecraft.diorite_stairs": "閃緑岩の階段",
  "block.minecraft.diorite_wall": "閃緑岩の塀",
  "block.minecraft.dirt": "土",
  "block.minecraft.dirt_path": "土の道",
  "block.minecraft.dispenser": "ディスペンサー",
  "block.minecraft.dragon_egg": "ドラゴンの卵",
  "block.minecraft.dragon_head": "ドラゴンの頭",
  "block.minecraft.dragon_wall_head": "壁に付けられたドラゴンの頭",
  "block.minecraft.dried_ghast": "乾燥したガスト",
  "block.minecraft.dried_kelp_block": "乾燥した昆布ブロック",
  "block.minecraft.dripstone_block": "鍾乳石ブロック",
  "block.minecraft.dropper": "ドロッパー",
  "block.minecraft.emerald_block": "エメラルドブロック",
  "block.minecraft.emerald_ore": "エメラルド鉱石",
  "block.minecraft.enchanting_table": "エンチャントテーブル",
  "block.minecraft.end_gateway": "エンドゲートウェイ",
  "block.minecraft.end_portal": "エンドポータル",
  "block.minecraft.end_portal_frame": "エンドポータルフレーム",
  "block.minecraft.end_rod": "エンドロッド",
  "block.minecraft.end_stone": "エンドストーン",
  "block.minecraft.end_stone_brick_slab": "エンドストーンレンガのハーフブロック",
  "block.minecraft.end_stone_brick_stairs": "エンドストーンレンガの階段",
  "block.minecraft.end_stone_brick_wall": "エンドストーンレンガの塀",
  "block.minecraft.end_stone_bricks": "エンドストーンレンガ",
  "block.minecraft.ender_chest": "エンダーチェスト",
  "block.minecraft.exposed_chiseled_copper": "風化した模様入りの銅",
  "block.minecraft.exposed_copper": "風化した銅",
  "block.minecraft.exposed_copper_bars": "風化した銅格子",
  "block.minecraft.exposed_copper_bulb": "風化した銅の電球",
  "block.minecraft.exposed_copper_chain": "風化した銅の鎖",
  "block.minecraft.exposed_copper_chest": "風化した銅のチェスト",
  "block.minecraft.exposed_copper_door": "風化した銅のドア",
  "block.minecraft.exposed_copper_golem_statue": "風化したカッパーゴーレムの像",
  "block.minecraft.exposed_copper_grate": "風化した銅の金網",
  "block.minecraft.exposed_copper_lantern": "風化した銅のランタン",
  "block.minecraft.exposed_copper_trapdoor": "風化した銅のトラップドア",
  "block.minecraft.exposed_cut_copper": "風化した切り込み入りの銅",
  "block.minecraft.exposed_cut_copper_slab": "風化した切り込み入りの銅のハーフブロック",
  "block.minecraft.exposed_cut_copper_stairs": "風化した切り込み入りの銅の階段",
  "block.minecraft.exposed_lightning_rod": "風化した避雷針",
  "block.minecraft.farmland": "耕地",
  "block.minecraft.fern": "シダ",
  "block.minecraft.fire": "炎",
  "block.minecraft.fire_coral": "ミレポラサンゴ",
  "block.minecraft.fire_coral_block": "ミレポラサンゴブロック",
  "block.minecraft.fire_coral_fan": "ミレポラウチワサンゴ",
  "block.minecraft.fire_coral_wall_fan": "壁付きのミレポラウチワサンゴ",
  "block.minecraft.firefly_bush": "ホタルの茂み",
  "block.minecraft.fletching_table": "矢細工台",
  "block.minecraft.flower_pot": "植木鉢",
  "block.minecraft.flowering_azalea": "開花したツツジ",
  "block.minecraft.flowering_azalea_leaves": "開花したツツジの葉",
  "block.minecraft.frogspawn": "カエルの卵",
  "block.minecraft.frosted_ice": "薄氷",
  "block.minecraft.furnace": "かまど",
  "block.minecraft.gilded_blackstone": "きらめくブラックストーン",
  "block.minecraft.glass": "ガラス",
  "block.minecraft.glass_pane": "ガラス板",
  "block.minecraft.glow_lichen": "ヒカリゴケ",
  "block.minecraft.glowstone": "グロウストーン",
  "block.minecraft.gold_block": "金ブロック",
  "block.minecraft.gold_ore": "金鉱石",
  "block.minecraft.golden_dandelion": "金のタンポポ",
  "block.minecraft.granite": "花崗岩",
  "block.minecraft.granite_slab": "花崗岩のハーフブロック",
  "block.minecraft.granite_stairs": "花崗岩の階段",
  "block.minecraft.granite_wall": "花崗岩の塀",
  "block.minecraft.grass": "草",
  "block.minecraft.grass_block": "草ブロック",
  "block.minecraft.gravel": "砂利",
  "block.minecraft.gray_banner": "灰色の旗",
  "block.minecraft.gray_bed": "灰色のベッド",
  "block.minecraft.gray_candle": "灰色のろうそく",
  "block.minecraft.gray_candle_cake": "灰色のろうそくが立てられたケーキ",
  "block.minecraft.gray_carpet": "灰色のカーペット",
  "block.minecraft.gray_concrete": "灰色のコンクリート",
  "block.minecraft.gray_concrete_powder": "灰色のコンクリートパウダー",
  "block.minecraft.gray_glazed_terracotta": "灰色の彩釉テラコッタ",
  "block.minecraft.gray_shulker_box": "灰色のシュルカーボックス",
  "block.minecraft.gray_stained_glass": "灰色の色付きガラス",
  "block.minecraft.gray_stained_glass_pane": "灰色の色付きガラス板",
  "block.minecraft.gray_terracotta": "灰色のテラコッタ",
  "block.minecraft.gray_wool": "灰色の羊毛",
  "block.minecraft.green_banner": "緑色の旗",
  "block.minecraft.green_bed": "緑色のベッド",
  "block.minecraft.green_candle": "緑色のろうそく",
  "block.minecraft.green_candle_cake": "緑色のろうそくが立てられたケーキ",
  "block.minecraft.green_carpet": "緑色のカーペット",
  "block.minecraft.green_concrete": "緑色のコンクリート",
  "block.minecraft.green_concrete_powder": "緑色のコンクリートパウダー",
  "block.minecraft.green_glazed_terracotta": "緑色の彩釉テラコッタ",
  "block.minecraft.green_shulker_box": "緑色のシュルカーボックス",
  "block.minecraft.green_stained_glass": "緑色の色付きガラス",
  "block.minecraft.green_stained_glass_pane": "緑色の色付きガラス板",
  "block.minecraft.green_terracotta": "緑色のテラコッタ",
  "block.minecraft.green_wool": "緑色の羊毛",
  "block.minecraft.grindstone": "砥石",
  "block.minecraft.hanging_roots": "垂れ根",
  "block.minecraft.hay_block": "干草の俵",
  "block.minecraft.heavy_core": "ヘビーコア",
  "block.minecraft.heavy_weighted_pressure_plate": "重量用感圧板",
  "block.minecraft.honey_block": "ハチミツブロック",
  "block.minecraft.honeycomb_block": "ハニカムブロック",
  "block.minecraft.hopper": "ホッパー",
  "block.minecraft.horn_coral": "シカツノサンゴ",
  "block.minecraft.horn_coral_block": "シカツノサンゴブロック",
  "block.minecraft.horn_coral_fan": "シカツノウチワサンゴ",
  "block.minecraft.horn_coral_wall_fan": "壁付きのシカツノウチワサンゴ",
  "block.minecraft.ice": "氷",
  "block.minecraft.infested_chiseled_stone_bricks": "模様入りの虫食い石レンガ",
  "block.minecraft.infested_cobblestone": "虫食い丸石",
  "block.minecraft.infested_cracked_stone_bricks": "ひび割れた虫食い石レンガ",
  "block.minecraft.infested_deepslate": "虫食い深層岩",
  "block.minecraft.infested_mossy_stone_bricks": "苔むした虫食い石レンガ",
  "block.minecraft.infested_stone": "虫食い石",
  "block.minecraft.infested_stone_bricks": "虫食い石レンガ",
  "block.minecraft.iron_bars": "鉄格子",
  "block.minecraft.iron_block": "鉄ブロック",
  "block.minecraft.iron_chain": "鉄の鎖",
  "block.minecraft.iron_door": "鉄のドア",
  "block.minecraft.iron_ore": "鉄鉱石",
  "block.minecraft.iron_trapdoor": "鉄のトラップドア",
  "block.minecraft.jack_o_lantern": "ジャック・オ・ランタン",
  "block.minecraft.jigsaw": "ジグソーブロック",
  "block.minecraft.jukebox": "ジュークボックス",
  "block.minecraft.jungle_button": "ジャングルのボタン",
  "block.minecraft.jungle_door": "ジャングルのドア",
  "block.minecraft.jungle_fence": "ジャングルのフェンス",
  "block.minecraft.jungle_fence_gate": "ジャングルのフェンスゲート",
  "block.minecraft.jungle_hanging_sign": "ジャングルの吊り看板",
  "block.minecraft.jungle_leaves": "ジャングルの葉",
  "block.minecraft.jungle_log": "ジャングルの原木",
  "block.minecraft.jungle_planks": "ジャングルの板材",
  "block.minecraft.jungle_pressure_plate": "ジャングルの感圧板",
  "block.minecraft.jungle_sapling": "ジャングルの苗木",
  "block.minecraft.jungle_shelf": "ジャングルの棚",
  "block.minecraft.jungle_sign": "ジャングルの看板",
  "block.minecraft.jungle_slab": "ジャングルのハーフブロック",
  "block.minecraft.jungle_stairs": "ジャングルの階段",
  "block.minecraft.jungle_trapdoor": "ジャングルのトラップドア",
  "block.minecraft.jungle_wall_hanging_sign": "壁に付けられたジャングルの吊り看板",
  "block.minecraft.jungle_wall_sign": "壁に付けられたジャングルの看板",
  "block.minecraft.jungle_wood": "ジャングルの木",
  "block.minecraft.kelp": "コンブ",
  "block.minecraft.kelp_plant": "コンブの茎",
  "block.minecraft.ladder": "はしご",
  "block.minecraft.lantern": "ランタン",
  "block.minecraft.lapis_block": "ラピスラズリブロック",
  "block.minecraft.lapis_ore": "ラピスラズリ鉱石",
  "block.minecraft.large_amethyst_bud": "大きなアメジストの芽",
  "block.minecraft.large_fern": "大きなシダ",
  "block.minecraft.lava": "溶岩",
  "block.minecraft.lava_cauldron": "溶岩入りの大釜",
  "block.minecraft.leaf_litter": "落ち葉",
  "block.minecraft.lectern": "書見台",
  "block.minecraft.lever": "レバー",
  "block.minecraft.light": "ライトブロック",
  "block.minecraft.light_blue_banner": "空色の旗",
  "block.minecraft.light_blue_bed": "空色のベッド",
  "block.minecraft.light_blue_candle": "空色のろうそく",
  "block.minecraft.light_blue_candle_cake": "空色のろうそくが立てられたケーキ",
  "block.minecraft.light_blue_carpet": "空色のカーペット",
  "block.minecraft.light_blue_concrete": "空色のコンクリート",
  "block.minecraft.light_blue_concrete_powder": "空色のコンクリートパウダー",
  "block.minecraft.light_blue_glazed_terracotta": "空色の彩釉テラコッタ",
  "block.minecraft.light_blue_shulker_box": "空色のシュルカーボックス",
  "block.minecraft.light_blue_stained_glass": "空色の色付きガラス",
  "block.minecraft.light_blue_stained_glass_pane": "空色の色付きガラス板",
  "block.minecraft.light_blue_terracotta": "空色のテラコッタ",
  "block.minecraft.light_blue_wool": "空色の羊毛",
  "block.minecraft.light_gray_banner": "薄灰色の旗",
  "block.minecraft.light_gray_bed": "薄灰色のベッド",
  "block.minecraft.light_gray_candle": "薄灰色のろうそく",
  "block.minecraft.light_gray_candle_cake": "薄灰色のろうそくが立てられたケーキ",
  "block.minecraft.light_gray_carpet": "薄灰色のカーペット",
  "block.minecraft.light_gray_concrete": "薄灰色のコンクリート",
  "block.minecraft.light_gray_concrete_powder": "薄灰色のコンクリートパウダー",
  "block.minecraft.light_gray_glazed_terracotta": "薄灰色の彩釉テラコッタ",
  "block.minecraft.light_gray_shulker_box": "薄灰色のシュルカーボックス",
  "block.minecraft.light_gray_stained_glass": "薄灰色の色付きガラス",
  "block.minecraft.light_gray_stained_glass_pane": "薄灰色の色付きガラス板",
  "block.minecraft.light_gray_terracotta": "薄灰色のテラコッタ",
  "block.minecraft.light_gray_wool": "薄灰色の羊毛",
  "block.minecraft.light_weighted_pressure_plate": "軽量用感圧板",
  "block.minecraft.lightning_rod": "避雷針",
  "block.minecraft.lilac": "ライラック",
  "block.minecraft.lily_of_the_valley": "スズラン",
  "block.minecraft.lily_pad": "スイレンの葉",
  "block.minecraft.lime_banner": "黄緑色の旗",
  "block.minecraft.lime_bed": "黄緑色のベッド",
  "block.minecraft.lime_candle": "黄緑色のろうそく",
  "block.minecraft.lime_candle_cake": "黄緑色のろうそくが立てられたケーキ",
  "block.minecraft.lime_carpet": "黄緑色のカーペット",
  "block.minecraft.lime_concrete": "黄緑色のコンクリート",
  "block.minecraft.lime_concrete_powder": "黄緑色のコンクリートパウダー",
  "block.minecraft.lime_glazed_terracotta": "黄緑色の彩釉テラコッタ",
  "block.minecraft.lime_shulker_box": "黄緑色のシュルカーボックス",
  "block.minecraft.lime_stained_glass": "黄緑色の色付きガラス",
  "block.minecraft.lime_stained_glass_pane": "黄緑色の色付きガラス板",
  "block.minecraft.lime_terracotta": "黄緑色のテラコッタ",
  "block.minecraft.lime_wool": "黄緑色の羊毛",
  "block.minecraft.lodestone": "ロードストーン",
  "block.minecraft.loom": "機織り機",
  "block.minecraft.magenta_banner": "赤紫色の旗",
  "block.minecraft.magenta_bed": "赤紫色のベッド",
  "block.minecraft.magenta_candle": "赤紫色のろうそく",
  "block.minecraft.magenta_candle_cake": "赤紫色のろうそくが立てられたケーキ",
  "block.minecraft.magenta_carpet": "赤紫色のカーペット",
  "block.minecraft.magenta_concrete": "赤紫色のコンクリート",
  "block.minecraft.magenta_concrete_powder": "赤紫色のコンクリートパウダー",
  "block.minecraft.magenta_glazed_terracotta": "赤紫色の彩釉テラコッタ",
  "block.minecraft.magenta_shulker_box": "赤紫色のシュルカーボックス",
  "block.minecraft.magenta_stained_glass": "赤紫色の色付きガラス",
  "block.minecraft.magenta_stained_glass_pane": "赤紫色の色付きガラス板",
  "block.minecraft.magenta_terracotta": "赤紫色のテラコッタ",
  "block.minecraft.magenta_wool": "赤紫色の羊毛",
  "block.minecraft.magma_block": "マグマブロック",
  "block.minecraft.mangrove_button": "マングローブのボタン",
  "block.minecraft.mangrove_door": "マングローブのドア",
  "block.minecraft.mangrove_fence": "マングローブのフェンス",
  "block.minecraft.mangrove_fence_gate": "マングローブのフェンスゲート",
  "block.minecraft.mangrove_hanging_sign": "マングローブの吊り看板",
  "block.minecraft.mangrove_leaves": "マングローブの葉",
  "block.minecraft.mangrove_log": "マングローブの原木",
  "block.minecraft.mangrove_planks": "マングローブの板材",
  "block.minecraft.mangrove_pressure_plate": "マングローブの感圧板",
  "block.minecraft.mangrove_propagule": "マングローブの芽",
  "block.minecraft.mangrove_roots": "マングローブの根",
  "block.minecraft.mangrove_shelf": "マングローブの棚",
  "block.minecraft.mangrove_sign": "マングローブの看板",
  "block.minecraft.mangrove_slab": "マングローブのハーフブロック",
  "block.minecraft.mangrove_stairs": "マングローブの階段",
  "block.minecraft.mangrove_trapdoor": "マングローブのトラップドア",
  "block.minecraft.mangrove_wall_hanging_sign": "壁に付けられたマングローブの吊り看板",
  "block.minecraft.mangrove_wall_sign": "壁に付けられたマングローブの看板",
  "block.minecraft.mangrove_wood": "マングローブの木",
  "block.minecraft.medium_amethyst_bud": "中くらいのアメジストの芽",
  "block.minecraft.melon": "スイカ",
  "block.minecraft.melon_stem": "スイカの茎",
  "block.minecraft.moss_block": "苔ブロック",
  "block.minecraft.moss_carpet": "苔のカーペット",
  "block.minecraft.mossy_cobblestone": "苔むした丸石",
  "block.minecraft.mossy_cobblestone_slab": "苔むした丸石のハーフブロック",
  "block.minecraft.mossy_cobblestone_stairs": "苔むした丸石の階段",
  "block.minecraft.mossy_cobblestone_wall": "苔むした丸石の塀",
  "block.minecraft.mossy_stone_brick_slab": "苔むした石レンガのハーフブロック",
  "block.minecraft.mossy_stone_brick_stairs": "苔むした石レンガの階段",
  "block.minecraft.mossy_stone_brick_wall": "苔むした石レンガの塀",
  "block.minecraft.mossy_stone_bricks": "苔むした石レンガ",
  "block.minecraft.moving_piston": "作動中のピストン",
  "block.minecraft.mud": "泥",
  "block.minecraft.mud_brick_slab": "泥レンガのハーフブロック",
  "block.minecraft.mud_brick_stairs": "泥レンガの階段",
  "block.minecraft.mud_brick_wall": "泥レンガの塀",
  "block.minecraft.mud_bricks": "泥レンガ",
  "block.minecraft.muddy_mangrove_roots": "泥だらけのマングローブの根",
  "block.minecraft.mushroom_stem": "キノコの柄",
  "block.minecraft.mycelium": "菌糸",
  "block.minecraft.nether_brick_fence": "ネザーレンガのフェンス",
  "block.minecraft.nether_brick_slab": "ネザーレンガのハーフブロック",
  "block.minecraft.nether_brick_stairs": "ネザーレンガの階段",
  "block.minecraft.nether_brick_wall": "ネザーレンガの塀",
  "block.minecraft.nether_bricks": "ネザーレンガ",
  "block.minecraft.nether_gold_ore": "ネザー金鉱石",
  "block.minecraft.nether_portal": "ネザーポータル",
  "block.minecraft.nether_quartz_ore": "ネザークォーツ鉱石",
  "block.minecraft.nether_sprouts": "ネザースプラウト",
  "block.minecraft.nether_wart": "ネザーウォート",
  "block.minecraft.nether_wart_block": "ネザーウォートブロック",
  "block.minecraft.netherite_block": "ネザライトブロック",
  "block.minecraft.netherrack": "ネザーラック",
  "block.minecraft.note_block": "音符ブロック",
  "block.minecraft.oak_button": "オークのボタン",
  "block.minecraft.oak_door": "オークのドア",
  "block.minecraft.oak_fence": "オークのフェンス",
  "block.minecraft.oak_fence_gate": "オークのフェンスゲート",
  "block.minecraft.oak_hanging_sign": "オークの吊り看板",
  "block.minecraft.oak_leaves": "オークの葉",
  "block.minecraft.oak_log": "オークの原木",
  "block.minecraft.oak_planks": "オークの板材",
  "block.minecraft.oak_pressure_plate": "オークの感圧板",
  "block.minecraft.oak_sapling": "オークの苗木",
  "block.minecraft.oak_shelf": "オークの棚",
  "block.minecraft.oak_sign": "オークの看板",
  "block.minecraft.oak_slab": "オークのハーフブロック",
  "block.minecraft.oak_stairs": "オークの階段",
  "block.minecraft.oak_trapdoor": "オークのトラップドア",
  "block.minecraft.oak_wall_hanging_sign": "壁に付けられたオークの吊り看板",
  "block.minecraft.oak_wall_sign": "壁に付けられたオークの看板",
  "block.minecraft.oak_wood": "オークの木",
  "block.minecraft.observer": "オブザーバー",
  "block.minecraft.obsidian": "黒曜石",
  "block.minecraft.ochre_froglight": "黄土色のフロッグライト",
  "block.minecraft.ominous_banner": "不吉な旗",
  "block.minecraft.open_eyeblossom": "開いたヒトミソウ",
  "block.minecraft.orange_banner": "橙色の旗",
  "block.minecraft.orange_bed": "橙色のベッド",
  "block.minecraft.orange_candle": "橙色のろうそく",
  "block.minecraft.orange_candle_cake": "橙色のろうそくが立てられたケーキ",
  "block.minecraft.orange_carpet": "橙色のカーペット",
  "block.minecraft.orange_concrete": "橙色のコンクリート",
  "block.minecraft.orange_concrete_powder": "橙色のコンクリートパウダー",
  "block.minecraft.orange_glazed_terracotta": "橙色の彩釉テラコッタ",
  "block.minecraft.orange_shulker_box": "橙色のシュルカーボックス",
  "block.minecraft.orange_stained_glass": "橙色の色付きガラス",
  "block.minecraft.orange_stained_glass_pane": "橙色の色付きガラス板",
  "block.minecraft.orange_terracotta": "橙色のテラコッタ",
  "block.minecraft.orange_tulip": "橙色のチューリップ",
  "block.minecraft.orange_wool": "橙色の羊毛",
  "block.minecraft.oxeye_daisy": "フランスギク",
  "block.minecraft.oxidized_chiseled_copper": "酸化した模様入りの銅",
  "block.minecraft.oxidized_copper": "酸化した銅",
  "block.minecraft.oxidized_copper_bars": "酸化した銅格子",
  "block.minecraft.oxidized_copper_bulb": "酸化した銅の電球",
  "block.minecraft.oxidized_copper_chain": "酸化した銅の鎖",
  "block.minecraft.oxidized_copper_chest": "酸化した銅のチェスト",
  "block.minecraft.oxidized_copper_door": "酸化した銅のドア",
  "block.minecraft.oxidized_copper_golem_statue": "酸化したカッパーゴーレムの像",
  "block.minecraft.oxidized_copper_grate": "酸化した銅の金網",
  "block.minecraft.oxidized_copper_lantern": "酸化した銅のランタン",
  "block.minecraft.oxidized_copper_trapdoor": "酸化した銅のトラップドア",
  "block.minecraft.oxidized_cut_copper": "酸化した切り込み入りの銅",
  "block.minecraft.oxidized_cut_copper_slab": "酸化した切り込み入りの銅のハーフブロック",
  "block.minecraft.oxidized_cut_copper_stairs": "酸化した切り込み入りの銅の階段",
  "block.minecraft.oxidized_lightning_rod": "酸化した避雷針",
  "block.minecraft.packed_ice": "氷塊",
  "block.minecraft.packed_mud": "固めた泥",
  "block.minecraft.pale_hanging_moss": "色あせた垂れ苔",
  "block.minecraft.pale_moss_block": "色あせた苔ブロック",
  "block.minecraft.pale_moss_carpet": "色あせた苔のカーペット",
  "block.minecraft.pale_oak_button": "ペールオークのボタン",
  "block.minecraft.pale_oak_door": "ペールオークのドア",
  "block.minecraft.pale_oak_fence": "ペールオークのフェンス",
  "block.minecraft.pale_oak_fence_gate": "ペールオークのフェンスゲート",
  "block.minecraft.pale_oak_hanging_sign": "ペールオークの吊り看板",
  "block.minecraft.pale_oak_leaves": "ペールオークの葉",
  "block.minecraft.pale_oak_log": "ペールオークの原木",
  "block.minecraft.pale_oak_planks": "ペールオークの板材",
  "block.minecraft.pale_oak_pressure_plate": "ペールオークの感圧板",
  "block.minecraft.pale_oak_sapling": "ペールオークの苗木",
  "block.minecraft.pale_oak_shelf": "ペールオークの棚",
  "block.minecraft.pale_oak_sign": "ペールオークの看板",
  "block.minecraft.pale_oak_slab": "ペールオークのハーフブロック",
  "block.minecraft.pale_oak_stairs": "ペールオークの階段",
  "block.minecraft.pale_oak_trapdoor": "ペールオークのトラップドア",
  "block.minecraft.pale_oak_wall_hanging_sign": "壁に付けられたペールオークの吊り看板",
  "block.minecraft.pale_oak_wall_sign": "壁に付けられたペールオークの看板",
  "block.minecraft.pale_oak_wood": "ペールオークの木",
  "block.minecraft.pearlescent_froglight": "真珠色のフロッグライト",
  "block.minecraft.peony": "ボタン",
  "block.minecraft.petrified_oak_slab": "石化したオークのハーフブロック",
  "block.minecraft.piglin_head": "ピグリンの頭",
  "block.minecraft.piglin_wall_head": "壁に付けられたピグリンの頭",
  "block.minecraft.pink_banner": "桃色の旗",
  "block.minecraft.pink_bed": "桃色のベッド",
  "block.minecraft.pink_candle": "桃色のろうそく",
  "block.minecraft.pink_candle_cake": "桃色のろうそくが立てられたケーキ",
  "block.minecraft.pink_carpet": "桃色のカーペット",
  "block.minecraft.pink_concrete": "桃色のコンクリート",
  "block.minecraft.pink_concrete_powder": "桃色のコンクリートパウダー",
  "block.minecraft.pink_glazed_terracotta": "桃色の彩釉テラコッタ",
  "block.minecraft.pink_petals": "桜色の花びら",
  "block.minecraft.pink_shulker_box": "桃色のシュルカーボックス",
  "block.minecraft.pink_stained_glass": "桃色の色付きガラス",
  "block.minecraft.pink_stained_glass_pane": "桃色の色付きガラス板",
  "block.minecraft.pink_terracotta": "桃色のテラコッタ",
  "block.minecraft.pink_tulip": "桃色のチューリップ",
  "block.minecraft.pink_wool": "桃色の羊毛",
  "block.minecraft.piston": "ピストン",
  "block.minecraft.piston_head": "ピストンヘッド",
  "block.minecraft.pitcher_crop": "ウツボカズラ",
  "block.minecraft.pitcher_plant": "ウツボカズラ",
  "block.minecraft.player_head": "プレイヤーの頭",
  "block.minecraft.player_head.named": "%sの頭",
  "block.minecraft.player_wall_head": "壁に付けられたプレイヤーの頭",
  "block.minecraft.podzol": "ポドゾル",
  "block.minecraft.pointed_dripstone": "鍾乳石",
  "block.minecraft.polished_andesite": "磨かれた安山岩",
  "block.minecraft.polished_andesite_slab": "磨かれた安山岩のハーフブロック",
  "block.minecraft.polished_andesite_stairs": "磨かれた安山岩の階段",
  "block.minecraft.polished_basalt": "磨かれた玄武岩",
  "block.minecraft.polished_blackstone": "磨かれたブラックストーン",
  "block.minecraft.polished_blackstone_brick_slab": "磨かれたブラックストーンレンガのハーフブロック",
  "block.minecraft.polished_blackstone_brick_stairs": "磨かれたブラックストーンレンガの階段",
  "block.minecraft.polished_blackstone_brick_wall": "磨かれたブラックストーンレンガの塀",
  "block.minecraft.polished_blackstone_bricks": "磨かれたブラックストーンレンガ",
  "block.minecraft.polished_blackstone_button": "磨かれたブラックストーンのボタン",
  "block.minecraft.polished_blackstone_pressure_plate": "磨かれたブラックストーンの感圧板",
  "block.minecraft.polished_blackstone_slab": "磨かれたブラックストーンのハーフブロック",
  "block.minecraft.polished_blackstone_stairs": "磨かれたブラックストーンの階段",
  "block.minecraft.polished_blackstone_wall": "磨かれたブラックストーンの塀",
  "block.minecraft.polished_deepslate": "磨かれた深層岩",
  "block.minecraft.polished_deepslate_slab": "磨かれた深層岩のハーフブロック",
  "block.minecraft.polished_deepslate_stairs": "磨かれた深層岩の階段",
  "block.minecraft.polished_deepslate_wall": "磨かれた深層岩の塀",
  "block.minecraft.polished_diorite": "磨かれた閃緑岩",
  "block.minecraft.polished_diorite_slab": "磨かれた閃緑岩のハーフブロック",
  "block.minecraft.polished_diorite_stairs": "磨かれた閃緑岩の階段",
  "block.minecraft.polished_granite": "磨かれた花崗岩",
  "block.minecraft.polished_granite_slab": "磨かれた花崗岩のハーフブロック",
  "block.minecraft.polished_granite_stairs": "磨かれた花崗岩の階段",
  "block.minecraft.polished_tuff": "磨かれた凝灰岩",
  "block.minecraft.polished_tuff_slab": "磨かれた凝灰岩のハーフブロック",
  "block.minecraft.polished_tuff_stairs": "磨かれた凝灰岩の階段",
  "block.minecraft.polished_tuff_wall": "磨かれた凝灰岩の塀",
  "block.minecraft.poppy": "ポピー",
  "block.minecraft.potatoes": "ジャガイモ",
  "block.minecraft.potted_acacia_sapling": "アカシアの苗木入り植木鉢",
  "block.minecraft.potted_allium": "アリウム入り植木鉢",
  "block.minecraft.potted_azalea_bush": "ツツジ入り植木鉢",
  "block.minecraft.potted_azure_bluet": "ヒナソウ入り植木鉢",
  "block.minecraft.potted_bamboo": "竹入り植木鉢",
  "block.minecraft.potted_birch_sapling": "シラカバの苗木入り植木鉢",
  "block.minecraft.potted_blue_orchid": "ヒスイラン入り植木鉢",
  "block.minecraft.potted_brown_mushroom": "茶色のキノコ入り植木鉢",
  "block.minecraft.potted_cactus": "サボテン入り植木鉢",
  "block.minecraft.potted_cherry_sapling": "サクラの苗木入り植木鉢",
  "block.minecraft.potted_closed_eyeblossom": "閉じたヒトミソウ入り植木鉢",
  "block.minecraft.potted_cornflower": "ヤグルマギク入り植木鉢",
  "block.minecraft.potted_crimson_fungus": "真紅のキノコ入り植木鉢",
  "block.minecraft.potted_crimson_roots": "真紅の根入り植木鉢",
  "block.minecraft.potted_dandelion": "タンポポ入り植木鉢",
  "block.minecraft.potted_dark_oak_sapling": "ダークオークの苗木入り植木鉢",
  "block.minecraft.potted_dead_bush": "枯れ木入り植木鉢",
  "block.minecraft.potted_fern": "シダ入り植木鉢",
  "block.minecraft.potted_flowering_azalea_bush": "開花したツツジ入り植木鉢",
  "block.minecraft.potted_golden_dandelion": "金のタンポポ入り植木鉢",
  "block.minecraft.potted_jungle_sapling": "ジャングルの苗木入り植木鉢",
  "block.minecraft.potted_lily_of_the_valley": "スズラン入り植木鉢",
  "block.minecraft.potted_mangrove_propagule": "マングローブの芽入り植木鉢",
  "block.minecraft.potted_oak_sapling": "オークの苗木入り植木鉢",
  "block.minecraft.potted_open_eyeblossom": "開いたヒトミソウ入り植木鉢",
  "block.minecraft.potted_orange_tulip": "橙色のチューリップ入り植木鉢",
  "block.minecraft.potted_oxeye_daisy": "フランスギク入り植木鉢",
  "block.minecraft.potted_pale_oak_sapling": "ペールオークの苗木入り植木鉢",
  "block.minecraft.potted_pink_tulip": "桃色のチューリップ入り植木鉢",
  "block.minecraft.potted_poppy": "ポピー入り植木鉢",
  "block.minecraft.potted_red_mushroom": "赤色のキノコ入り植木鉢",
  "block.minecraft.potted_red_tulip": "赤色のチューリップ入り植木鉢",
  "block.minecraft.potted_spruce_sapling": "トウヒの苗木入り植木鉢",
  "block.minecraft.potted_torchflower": "トーチフラワー入り植木鉢",
  "block.minecraft.potted_warped_fungus": "歪んだキノコ入り植木鉢",
  "block.minecraft.potted_warped_roots": "歪んだ根入り植木鉢",
  "block.minecraft.potted_white_tulip": "白色のチューリップ入り植木鉢",
  "block.minecraft.potted_wither_rose": "ウィザーローズ入り植木鉢",
  "block.minecraft.powder_snow": "粉雪",
  "block.minecraft.powder_snow_cauldron": "粉雪入りの大釜",
  "block.minecraft.powered_rail": "パワードレール",
  "block.minecraft.prismarine": "プリズマリン",
  "block.minecraft.prismarine_brick_slab": "プリズマリンレンガのハーフブロック",
  "block.minecraft.prismarine_brick_stairs": "プリズマリンレンガの階段",
  "block.minecraft.prismarine_bricks": "プリズマリンレンガ",
  "block.minecraft.prismarine_slab": "プリズマリンのハーフブロック",
  "block.minecraft.prismarine_stairs": "プリズマリンの階段",
  "block.minecraft.prismarine_wall": "プリズマリンの塀",
  "block.minecraft.pumpkin": "カボチャ",
  "block.minecraft.pumpkin_stem": "カボチャの茎",
  "block.minecraft.purple_banner": "紫色の旗",
  "block.minecraft.purple_bed": "紫色のベッド",
  "block.minecraft.purple_candle": "紫色のろうそく",
  "block.minecraft.purple_candle_cake": "紫色のろうそくが立てられたケーキ",
  "block.minecraft.purple_carpet": "紫色のカーペット",
  "block.minecraft.purple_concrete": "紫色のコンクリート",
  "block.minecraft.purple_concrete_powder": "紫色のコンクリートパウダー",
  "block.minecraft.purple_glazed_terracotta": "紫色の彩釉テラコッタ",
  "block.minecraft.purple_shulker_box": "紫色のシュルカーボックス",
  "block.minecraft.purple_stained_glass": "紫色の色付きガラス",
  "block.minecraft.purple_stained_glass_pane": "紫色の色付きガラス板",
  "block.minecraft.purple_terracotta": "紫色のテラコッタ",
  "block.minecraft.purple_wool": "紫色の羊毛",
  "block.minecraft.purpur_block": "プルプァブロック",
  "block.minecraft.purpur_pillar": "プルプァの柱",
  "block.minecraft.purpur_slab": "プルプァのハーフブロック",
  "block.minecraft.purpur_stairs": "プルプァの階段",
  "block.minecraft.quartz_block": "クォーツブロック",
  "block.minecraft.quartz_bricks": "クォーツレンガ",
  "block.minecraft.quartz_pillar": "クォーツの柱",
  "block.minecraft.quartz_slab": "クォーツのハーフブロック",
  "block.minecraft.quartz_stairs": "クォーツの階段",
  "block.minecraft.rail": "レール",
  "block.minecraft.raw_copper_block": "銅の原石ブロック",
  "block.minecraft.raw_gold_block": "金の原石ブロック",
  "block.minecraft.raw_iron_block": "鉄の原石ブロック",
  "block.minecraft.red_banner": "赤色の旗",
  "block.minecraft.red_bed": "赤色のベッド",
  "block.minecraft.red_candle": "赤色のろうそく",
  "block.minecraft.red_candle_cake": "赤色のろうそくが立てられたケーキ",
  "block.minecraft.red_carpet": "赤色のカーペット",
  "block.minecraft.red_concrete": "赤色のコンクリート",
  "block.minecraft.red_concrete_powder": "赤色のコンクリートパウダー",
  "block.minecraft.red_glazed_terracotta": "赤色の彩釉テラコッタ",
  "block.minecraft.red_mushroom": "赤色のキノコ",
  "block.minecraft.red_mushroom_block": "赤色のキノコブロック",
  "block.minecraft.red_nether_brick_slab": "赤いネザーレンガのハーフブロック",
  "block.minecraft.red_nether_brick_stairs": "赤いネザーレンガの階段",
  "block.minecraft.red_nether_brick_wall": "赤いネザーレンガの塀",
  "block.minecraft.red_nether_bricks": "赤いネザーレンガ",
  "block.minecraft.red_sand": "赤い砂",
  "block.minecraft.red_sandstone": "赤い砂岩",
  "block.minecraft.red_sandstone_slab": "赤い砂岩のハーフブロック",
  "block.minecraft.red_sandstone_stairs": "赤い砂岩の階段",
  "block.minecraft.red_sandstone_wall": "赤い砂岩の塀",
  "block.minecraft.red_shulker_box": "赤色のシュルカーボックス",
  "block.minecraft.red_stained_glass": "赤色の色付きガラス",
  "block.minecraft.red_stained_glass_pane": "赤色の色付きガラス板",
  "block.minecraft.red_terracotta": "赤色のテラコッタ",
  "block.minecraft.red_tulip": "赤色のチューリップ",
  "block.minecraft.red_wool": "赤色の羊毛",
  "block.minecraft.redstone_block": "レッドストーンブロック",
  "block.minecraft.redstone_lamp": "レッドストーンランプ",
  "block.minecraft.redstone_ore": "レッドストーン鉱石",
  "block.minecraft.redstone_torch": "レッドストーントーチ",
  "block.minecraft.redstone_wall_torch": "壁に付けられたレッドストーントーチ",
  "block.minecraft.redstone_wire": "レッドストーンワイヤー",
  "block.minecraft.reinforced_deepslate": "強化された深層岩",
  "block.minecraft.repeater": "レッドストーンリピーター",
  "block.minecraft.repeating_command_block": "リピートコマンドブロック",
  "block.minecraft.resin_block": "樹脂ブロック",
  "block.minecraft.resin_brick_slab": "樹脂レンガのハーフブロック",
  "block.minecraft.resin_brick_stairs": "樹脂レンガの階段",
  "block.minecraft.resin_brick_wall": "樹脂レンガの塀",
  "block.minecraft.resin_bricks": "樹脂レンガ",
  "block.minecraft.resin_clump": "樹脂の塊",
  "block.minecraft.respawn_anchor": "リスポーンアンカー",
  "block.minecraft.rooted_dirt": "根付いた土",
  "block.minecraft.rose_bush": "バラの低木",
  "block.minecraft.sand": "砂",
  "block.minecraft.sandstone": "砂岩",
  "block.minecraft.sandstone_slab": "砂岩のハーフブロック",
  "block.minecraft.sandstone_stairs": "砂岩の階段",
  "block.minecraft.sandstone_wall": "砂岩の塀",
  "block.minecraft.scaffolding": "足場",
  "block.minecraft.sculk": "スカルク",
  "block.minecraft.sculk_catalyst": "スカルクカタリスト",
  "block.minecraft.sculk_sensor": "スカルクセンサー",
  "block.minecraft.sculk_shrieker": "スカルクシュリーカー",
  "block.minecraft.sculk_vein": "スカルクヴェイン",
  "block.minecraft.sea_lantern": "シーランタン",
  "block.minecraft.sea_pickle": "シーピクルス",
  "block.minecraft.seagrass": "海草",
  "block.minecraft.set_spawn": "リスポーン地点が設定されました",
  "block.minecraft.short_dry_grass": "背の低い枯れ草",
  "block.minecraft.short_grass": "背の低い草",
  "block.minecraft.shroomlight": "シュルームライト",
  "block.minecraft.shulker_box": "シュルカーボックス",
  "block.minecraft.skeleton_skull": "スケルトンの頭蓋骨",
  "block.minecraft.skeleton_wall_skull": "壁に付けられたスケルトンの頭蓋骨",
  "block.minecraft.slime_block": "スライムブロック",
  "block.minecraft.small_amethyst_bud": "小さなアメジストの芽",
  "block.minecraft.small_dripleaf": "小さなドリップリーフ",
  "block.minecraft.smithing_table": "鍛冶台",
  "block.minecraft.smoker": "燻製器",
  "block.minecraft.smooth_basalt": "滑らかな玄武岩",
  "block.minecraft.smooth_quartz": "滑らかなクォーツブロック",
  "block.minecraft.smooth_quartz_slab": "滑らかなクォーツのハーフブロック",
  "block.minecraft.smooth_quartz_stairs": "滑らかなクォーツの階段",
  "block.minecraft.smooth_red_sandstone": "滑らかな赤い砂岩",
  "block.minecraft.smooth_red_sandstone_slab": "滑らかな赤い砂岩のハーフブロック",
  "block.minecraft.smooth_red_sandstone_stairs": "滑らかな赤い砂岩の階段",
  "block.minecraft.smooth_sandstone": "滑らかな砂岩",
  "block.minecraft.smooth_sandstone_slab": "滑らかな砂岩のハーフブロック",
  "block.minecraft.smooth_sandstone_stairs": "滑らかな砂岩の階段",
  "block.minecraft.smooth_stone": "滑らかな石",
  "block.minecraft.smooth_stone_slab": "滑らかな石のハーフブロック",
  "block.minecraft.sniffer_egg": "スニッファーの卵",
  "block.minecraft.snow": "雪",
  "block.minecraft.snow_block": "雪ブロック",
  "block.minecraft.soul_campfire": "魂の焚き火",
  "block.minecraft.soul_fire": "魂の炎",
  "block.minecraft.soul_lantern": "魂のランタン",
  "block.minecraft.soul_sand": "ソウルサンド",
  "block.minecraft.soul_soil": "ソウルソイル",
  "block.minecraft.soul_torch": "魂の松明",
  "block.minecraft.soul_wall_torch": "壁に付けられた魂の松明",
  "block.minecraft.spawn.not_valid": "ベッドもしくはチャージされたリスポーンアンカーが存在しないか、あるいは塞がれています。",
  "block.minecraft.spawner": "モンスタースポナー",
  "block.minecraft.spawner.desc1": "スポーンエッグを使用：",
  "block.minecraft.spawner.desc2": "Mobの種類を設定",
  "block.minecraft.sponge": "スポンジ",
  "block.minecraft.spore_blossom": "胞子の花",
  "block.minecraft.spruce_button": "トウヒのボタン",
  "block.minecraft.spruce_door": "トウヒのドア",
  "block.minecraft.spruce_fence": "トウヒのフェンス",
  "block.minecraft.spruce_fence_gate": "トウヒのフェンスゲート",
  "block.minecraft.spruce_hanging_sign": "トウヒの吊り看板",
  "block.minecraft.spruce_leaves": "トウヒの葉",
  "block.minecraft.spruce_log": "トウヒの原木",
  "block.minecraft.spruce_planks": "トウヒの板材",
  "block.minecraft.spruce_pressure_plate": "トウヒの感圧板",
  "block.minecraft.spruce_sapling": "トウヒの苗木",
  "block.minecraft.spruce_shelf": "トウヒの棚",
  "block.minecraft.spruce_sign": "トウヒの看板",
  "block.minecraft.spruce_slab": "トウヒのハーフブロック",
  "block.minecraft.spruce_stairs": "トウヒの階段",
  "block.minecraft.spruce_trapdoor": "トウヒのトラップドア",
  "block.minecraft.spruce_wall_hanging_sign": "壁に付けられたトウヒの吊り看板",
  "block.minecraft.spruce_wall_sign": "壁に付けられたトウヒの看板",
  "block.minecraft.spruce_wood": "トウヒの木",
  "block.minecraft.sticky_piston": "粘着ピストン",
  "block.minecraft.stone": "石",
  "block.minecraft.stone_brick_slab": "石レンガのハーフブロック",
  "block.minecraft.stone_brick_stairs": "石レンガの階段",
  "block.minecraft.stone_brick_wall": "石レンガの塀",
  "block.minecraft.stone_bricks": "石レンガ",
  "block.minecraft.stone_button": "石のボタン",
  "block.minecraft.stone_pressure_plate": "石の感圧板",
  "block.minecraft.stone_slab": "石のハーフブロック",
  "block.minecraft.stone_stairs": "石の階段",
  "block.minecraft.stonecutter": "石切台",
  "block.minecraft.stripped_acacia_log": "樹皮を剥いだアカシアの原木",
  "block.minecraft.stripped_acacia_wood": "樹皮を剥いだアカシアの木",
  "block.minecraft.stripped_bamboo_block": "表皮を剥いだ竹ブロック",
  "block.minecraft.stripped_birch_log": "樹皮を剥いだシラカバの原木",
  "block.minecraft.stripped_birch_wood": "樹皮を剥いだシラカバの木",
  "block.minecraft.stripped_cherry_log": "樹皮を剥いだサクラの原木",
  "block.minecraft.stripped_cherry_wood": "樹皮を剥いだサクラの木",
  "block.minecraft.stripped_crimson_hyphae": "表皮を剥いだ真紅の菌糸",
  "block.minecraft.stripped_crimson_stem": "表皮を剥いだ真紅の幹",
  "block.minecraft.stripped_dark_oak_log": "樹皮を剥いだダークオークの原木",
  "block.minecraft.stripped_dark_oak_wood": "樹皮を剥いだダークオークの木",
  "block.minecraft.stripped_jungle_log": "樹皮を剥いだジャングルの原木",
  "block.minecraft.stripped_jungle_wood": "樹皮を剥いだジャングルの木",
  "block.minecraft.stripped_mangrove_log": "樹皮を剥いだマングローブの原木",
  "block.minecraft.stripped_mangrove_wood": "樹皮を剥いだマングローブの木",
  "block.minecraft.stripped_oak_log": "樹皮を剥いだオークの原木",
  "block.minecraft.stripped_oak_wood": "樹皮を剥いだオークの木",
  "block.minecraft.stripped_pale_oak_log": "樹皮を剥いだペールオークの原木",
  "block.minecraft.stripped_pale_oak_wood": "樹皮を剥いだペールオークの木",
  "block.minecraft.stripped_spruce_log": "樹皮を剥いだトウヒの原木",
  "block.minecraft.stripped_spruce_wood": "樹皮を剥いだトウヒの木",
  "block.minecraft.stripped_warped_hyphae": "表皮を剥いだ歪んだ菌糸",
  "block.minecraft.stripped_warped_stem": "表皮を剥いだ歪んだ幹",
  "block.minecraft.structure_block": "ストラクチャーブロック",
  "block.minecraft.structure_void": "ストラクチャーヴォイド",
  "block.minecraft.sugar_cane": "サトウキビ",
  "block.minecraft.sunflower": "ヒマワリ",
  "block.minecraft.suspicious_gravel": "怪しげな砂利",
  "block.minecraft.suspicious_sand": "怪しげな砂",
  "block.minecraft.sweet_berry_bush": "スイートベリーの低木",
  "block.minecraft.tall_dry_grass": "背の高い枯れ草",
  "block.minecraft.tall_grass": "背の高い草",
  "block.minecraft.tall_seagrass": "背の高い海草",
  "block.minecraft.target": "的",
  "block.minecraft.terracotta": "テラコッタ",
  "block.minecraft.test_block": "テストブロック",
  "block.minecraft.test_instance_block": "テストインスタンスブロック",
  "block.minecraft.tinted_glass": "遮光ガラス",
  "block.minecraft.tnt": "TNT",
  "block.minecraft.tnt.disabled": "TNTの爆発は無効化されています",
  "block.minecraft.torch": "松明",
  "block.minecraft.torchflower": "トーチフラワー",
  "block.minecraft.torchflower_crop": "トーチフラワー",
  "block.minecraft.trapped_chest": "トラップチェスト",
  "block.minecraft.trial_spawner": "試練のスポナー",
  "block.minecraft.tripwire": "トリップワイヤー",
  "block.minecraft.tripwire_hook": "トリップワイヤーフック",
  "block.minecraft.tube_coral": "クダサンゴ",
  "block.minecraft.tube_coral_block": "クダサンゴブロック",
  "block.minecraft.tube_coral_fan": "クダウチワサンゴ",
  "block.minecraft.tube_coral_wall_fan": "壁付きのクダウチワサンゴ",
  "block.minecraft.tuff": "凝灰岩",
  "block.minecraft.tuff_brick_slab": "凝灰岩レンガのハーフブロック",
  "block.minecraft.tuff_brick_stairs": "凝灰岩レンガの階段",
  "block.minecraft.tuff_brick_wall": "凝灰岩レンガの塀",
  "block.minecraft.tuff_bricks": "凝灰岩レンガ",
  "block.minecraft.tuff_slab": "凝灰岩のハーフブロック",
  "block.minecraft.tuff_stairs": "凝灰岩の階段",
  "block.minecraft.tuff_wall": "凝灰岩の塀",
  "block.minecraft.turtle_egg": "カメの卵",
  "block.minecraft.twisting_vines": "ねじれツタ",
  "block.minecraft.twisting_vines_plant": "ねじれツタのつる",
  "block.minecraft.vault": "宝物庫",
  "block.minecraft.verdant_froglight": "新緑色のフロッグライト",
  "block.minecraft.vine": "ツタ",
  "block.minecraft.void_air": "奈落の空気",
  "block.minecraft.wall_torch": "壁に付けられた松明",
  "block.minecraft.warped_button": "歪んだボタン",
  "block.minecraft.warped_door": "歪んだドア",
  "block.minecraft.warped_fence": "歪んだフェンス",
  "block.minecraft.warped_fence_gate": "歪んだフェンスゲート",
  "block.minecraft.warped_fungus": "歪んだキノコ",
  "block.minecraft.warped_hanging_sign": "歪んだ吊り看板",
  "block.minecraft.warped_hyphae": "歪んだ菌糸",
  "block.minecraft.warped_nylium": "歪んだナイリウム",
  "block.minecraft.warped_planks": "歪んだ板材",
  "block.minecraft.warped_pressure_plate": "歪んだ感圧板",
  "block.minecraft.warped_roots": "歪んだ根",
  "block.minecraft.warped_shelf": "歪んだ棚",
  "block.minecraft.warped_sign": "歪んだ看板",
  "block.minecraft.warped_slab": "歪んだハーフブロック",
  "block.minecraft.warped_stairs": "歪んだ階段",
  "block.minecraft.warped_stem": "歪んだ幹",
  "block.minecraft.warped_trapdoor": "歪んだトラップドア",
  "block.minecraft.warped_wall_hanging_sign": "壁に付けられた歪んだ吊り看板",
  "block.minecraft.warped_wall_sign": "壁に付けられた歪んだ看板",
  "block.minecraft.warped_wart_block": "歪んだウォートブロック",
  "block.minecraft.water": "水",
  "block.minecraft.water_cauldron": "水入りの大釜",
  "block.minecraft.waxed_chiseled_copper": "錆止めされた模様入りの銅",
  "block.minecraft.waxed_copper_bars": "錆止めされた銅格子",
  "block.minecraft.waxed_copper_block": "錆止めされた銅ブロック",
  "block.minecraft.waxed_copper_bulb": "錆止めされた銅の電球",
  "block.minecraft.waxed_copper_chain": "錆止めされた銅の鎖",
  "block.minecraft.waxed_copper_chest": "錆止めされた銅のチェスト",
  "block.minecraft.waxed_copper_door": "錆止めされた銅のドア",
  "block.minecraft.waxed_copper_golem_statue": "錆止めされたカッパーゴーレムの像",
  "block.minecraft.waxed_copper_grate": "錆止めされた銅の金網",
  "block.minecraft.waxed_copper_lantern": "錆止めされた銅のランタン",
  "block.minecraft.waxed_copper_trapdoor": "錆止めされた銅のトラップドア",
  "block.minecraft.waxed_cut_copper": "錆止めされた切り込み入りの銅",
  "block.minecraft.waxed_cut_copper_slab": "錆止めされた切り込み入りの銅のハーフブロック",
  "block.minecraft.waxed_cut_copper_stairs": "錆止めされた切り込み入りの銅の階段",
  "block.minecraft.waxed_exposed_chiseled_copper": "錆止めされた風化した模様入りの銅",
  "block.minecraft.waxed_exposed_copper": "錆止めされた風化した銅",
  "block.minecraft.waxed_exposed_copper_bars": "錆止めされた風化した銅格子",
  "block.minecraft.waxed_exposed_copper_bulb": "錆止めされた風化した銅の電球",
  "block.minecraft.waxed_exposed_copper_chain": "錆止めされた風化した銅の鎖",
  "block.minecraft.waxed_exposed_copper_chest": "錆止めされた風化した銅のチェスト",
  "block.minecraft.waxed_exposed_copper_door": "錆止めされた風化した銅のドア",
  "block.minecraft.waxed_exposed_copper_golem_statue": "錆止めされた風化したカッパーゴーレムの像",
  "block.minecraft.waxed_exposed_copper_grate": "錆止めされた風化した銅の金網",
  "block.minecraft.waxed_exposed_copper_lantern": "錆止めされた風化した銅のランタン",
  "block.minecraft.waxed_exposed_copper_trapdoor": "錆止めされた風化した銅のトラップドア",
  "block.minecraft.waxed_exposed_cut_copper": "錆止めされた風化した切り込み入りの銅",
  "block.minecraft.waxed_exposed_cut_copper_slab": "錆止めされた風化した切り込み入りの銅のハーフブロック",
  "block.minecraft.waxed_exposed_cut_copper_stairs": "錆止めされた風化した切り込み入りの銅の階段",
  "block.minecraft.waxed_exposed_lightning_rod": "錆止めされた風化した避雷針",
  "block.minecraft.waxed_lightning_rod": "錆止めされた避雷針",
  "block.minecraft.waxed_oxidized_chiseled_copper": "錆止めされた酸化した模様入りの銅",
  "block.minecraft.waxed_oxidized_copper": "錆止めされた酸化した銅",
  "block.minecraft.waxed_oxidized_copper_bars": "錆止めされた酸化した銅格子",
  "block.minecraft.waxed_oxidized_copper_bulb": "錆止めされた酸化した銅の電球",
  "block.minecraft.waxed_oxidized_copper_chain": "錆止めされた酸化した銅の鎖",
  "block.minecraft.waxed_oxidized_copper_chest": "錆止めされた酸化した銅のチェスト",
  "block.minecraft.waxed_oxidized_copper_door": "錆止めされた酸化した銅のドア",
  "block.minecraft.waxed_oxidized_copper_golem_statue": "錆止めされた酸化したカッパーゴーレムの像",
  "block.minecraft.waxed_oxidized_copper_grate": "錆止めされた酸化した銅の金網",
  "block.minecraft.waxed_oxidized_copper_lantern": "錆止めされた酸化した銅のランタン",
  "block.minecraft.waxed_oxidized_copper_trapdoor": "錆止めされた酸化した銅のトラップドア",
  "block.minecraft.waxed_oxidized_cut_copper": "錆止めされた酸化した切り込み入りの銅",
  "block.minecraft.waxed_oxidized_cut_copper_slab": "錆止めされた酸化した切り込み入りの銅のハーフブロック",
  "block.minecraft.waxed_oxidized_cut_copper_stairs": "錆止めされた酸化した切り込み入りの銅の階段",
  "block.minecraft.waxed_oxidized_lightning_rod": "錆止めされた酸化した避雷針",
  "block.minecraft.waxed_weathered_chiseled_copper": "錆止めされた錆びた模様入りの銅",
  "block.minecraft.waxed_weathered_copper": "錆止めされた錆びた銅",
  "block.minecraft.waxed_weathered_copper_bars": "錆止めされた錆びた銅格子",
  "block.minecraft.waxed_weathered_copper_bulb": "錆止めされた錆びた銅の電球",
  "block.minecraft.waxed_weathered_copper_chain": "錆止めされた錆びた銅の鎖",
  "block.minecraft.waxed_weathered_copper_chest": "錆止めされた錆びた銅のチェスト",
  "block.minecraft.waxed_weathered_copper_door": "錆止めされた錆びた銅のドア",
  "block.minecraft.waxed_weathered_copper_golem_statue": "錆止めされた錆びたカッパーゴーレムの像",
  "block.minecraft.waxed_weathered_copper_grate": "錆止めされた錆びた銅の金網",
  "block.minecraft.waxed_weathered_copper_lantern": "錆止めされた錆びた銅のランタン",
  "block.minecraft.waxed_weathered_copper_trapdoor": "錆止めされた錆びた銅のトラップドア",
  "block.minecraft.waxed_weathered_cut_copper": "錆止めされた錆びた切り込み入りの銅",
  "block.minecraft.waxed_weathered_cut_copper_slab": "錆止めされた錆びた切り込み入りの銅のハーフブロック",
  "block.minecraft.waxed_weathered_cut_copper_stairs": "錆止めされた錆びた切り込み入りの銅の階段",
  "block.minecraft.waxed_weathered_lightning_rod": "錆止めされた錆びた避雷針",
  "block.minecraft.weathered_chiseled_copper": "錆びた模様入りの銅",
  "block.minecraft.weathered_copper": "錆びた銅",
  "block.minecraft.weathered_copper_bars": "錆びた銅格子",
  "block.minecraft.weathered_copper_bulb": "錆びた銅の電球",
  "block.minecraft.weathered_copper_chain": "錆びた銅の鎖",
  "block.minecraft.weathered_copper_chest": "錆びた銅のチェスト",
  "block.minecraft.weathered_copper_door": "錆びた銅のドア",
  "block.minecraft.weathered_copper_golem_statue": "錆びたカッパーゴーレムの像",
  "block.minecraft.weathered_copper_grate": "錆びた銅の金網",
  "block.minecraft.weathered_copper_lantern": "錆びた銅のランタン",
  "block.minecraft.weathered_copper_trapdoor": "錆びた銅のトラップドア",
  "block.minecraft.weathered_cut_copper": "錆びた切り込み入りの銅",
  "block.minecraft.weathered_cut_copper_slab": "錆びた切り込み入りの銅のハーフブロック",
  "block.minecraft.weathered_cut_copper_stairs": "錆びた切り込み入りの銅の階段",
  "block.minecraft.weathered_lightning_rod": "錆びた避雷針",
  "block.minecraft.weeping_vines": "しだれツタ",
  "block.minecraft.weeping_vines_plant": "しだれツタのつる",
  "block.minecraft.wet_sponge": "濡れたスポンジ",
  "block.minecraft.wheat": "小麦",
  "block.minecraft.white_banner": "白色の旗",
  "block.minecraft.white_bed": "白色のベッド",
  "block.minecraft.white_candle": "白色のろうそく",
  "block.minecraft.white_candle_cake": "白色のろうそくが立てられたケーキ",
  "block.minecraft.white_carpet": "白色のカーペット",
  "block.minecraft.white_concrete": "白色のコンクリート",
  "block.minecraft.white_concrete_powder": "白色のコンクリートパウダー",
  "block.minecraft.white_glazed_terracotta": "白色の彩釉テラコッタ",
  "block.minecraft.white_shulker_box": "白色のシュルカーボックス",
  "block.minecraft.white_stained_glass": "白色の色付きガラス",
  "block.minecraft.white_stained_glass_pane": "白色の色付きガラス板",
  "block.minecraft.white_terracotta": "白色のテラコッタ",
  "block.minecraft.white_tulip": "白色のチューリップ",
  "block.minecraft.white_wool": "白色の羊毛",
  "block.minecraft.wildflowers": "野花",
  "block.minecraft.wither_rose": "ウィザーローズ",
  "block.minecraft.wither_skeleton_skull": "ウィザースケルトンの頭蓋骨",
  "block.minecraft.wither_skeleton_wall_skull": "壁に付けられたウィザースケルトンの頭蓋骨",
  "block.minecraft.yellow_banner": "黄色の旗",
  "block.minecraft.yellow_bed": "黄色のベッド",
  "block.minecraft.yellow_candle": "黄色のろうそく",
  "block.minecraft.yellow_candle_cake": "黄色のろうそくが立てられたケーキ",
  "block.minecraft.yellow_carpet": "黄色のカーペット",
  "block.minecraft.yellow_concrete": "黄色のコンクリート",
  "block.minecraft.yellow_concrete_powder": "黄色のコンクリートパウダー",
  "block.minecraft.yellow_glazed_terracotta": "黄色の彩釉テラコッタ",
  "block.minecraft.yellow_shulker_box": "黄色のシュルカーボックス",
  "block.minecraft.yellow_stained_glass": "黄色の色付きガラス",
  "block.minecraft.yellow_stained_glass_pane": "黄色の色付きガラス板",
  "block.minecraft.yellow_terracotta": "黄色のテラコッタ",
  "block.minecraft.yellow_wool": "黄色の羊毛",
  "block.minecraft.zombie_head": "ゾンビの頭",
  "block.minecraft.zombie_wall_head": "壁に付けられたゾンビの頭",
  "item.minecraft.acacia_boat": "アカシアのボート",
  "item.minecraft.acacia_chest_boat": "チェスト付きのアカシアのボート",
  "item.minecraft.allay_spawn_egg": "アレイのスポーンエッグ",
  "item.minecraft.amethyst_shard": "アメジストの欠片",
  "item.minecraft.angler_pottery_shard": "釣り人の壺の欠片",
  "item.minecraft.angler_pottery_sherd": "釣り人の壺の欠片",
  "item.minecraft.apple": "リンゴ",
  "item.minecraft.archer_pottery_shard": "射手の壺の欠片",
  "item.minecraft.archer_pottery_sherd": "射手の壺の欠片",
  "item.minecraft.armadillo_scute": "アルマジロのウロコ",
  "item.minecraft.armadillo_spawn_egg": "アルマジロのスポーンエッグ",
  "item.minecraft.armor_stand": "防具立て",
  "item.minecraft.arms_up_pottery_shard": "両腕を上げた人の壺の欠片",
  "item.minecraft.arms_up_pottery_sherd": "両腕を上げた人の壺の欠片",
  "item.minecraft.arrow": "矢",
  "item.minecraft.axolotl_bucket": "ウーパールーパー入りバケツ",
  "item.minecraft.axolotl_spawn_egg": "ウーパールーパーのスポーンエッグ",
  "item.minecraft.baked_potato": "ベイクドポテト",
  "item.minecraft.bamboo_chest_raft": "チェスト付きの竹のイカダ",
  "item.minecraft.bamboo_raft": "竹のイカダ",
  "item.minecraft.bat_spawn_egg": "コウモリのスポーンエッグ",
  "item.minecraft.bee_spawn_egg": "ミツバチのスポーンエッグ",
  "item.minecraft.beef": "生の牛肉",
  "item.minecraft.beetroot": "ビートルート",
  "item.minecraft.beetroot_seeds": "ビートルートの種",
  "item.minecraft.beetroot_soup": "ビートルートスープ",
  "item.minecraft.birch_boat": "シラカバのボート",
  "item.minecraft.birch_chest_boat": "チェスト付きのシラカバのボート",
  "item.minecraft.black_bundle": "黒色のバンドル",
  "item.minecraft.black_dye": "黒色の染料",
  "item.minecraft.black_harness": "黒色のハーネス",
  "item.minecraft.blade_pottery_shard": "剣の壺の欠片",
  "item.minecraft.blade_pottery_sherd": "剣の壺の欠片",
  "item.minecraft.blaze_powder": "ブレイズパウダー",
  "item.minecraft.blaze_rod": "ブレイズロッド",
  "item.minecraft.blaze_spawn_egg": "ブレイズのスポーンエッグ",
  "item.minecraft.blue_bundle": "青色のバンドル",
  "item.minecraft.blue_dye": "青色の染料",
  "item.minecraft.blue_egg": "青色の卵",
  "item.minecraft.blue_harness": "青色のハーネス",
  "item.minecraft.bogged_spawn_egg": "ボグドのスポーンエッグ",
  "item.minecraft.bolt_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.bolt_armor_trim_smithing_template.new": "ネジ止め風の装飾",
  "item.minecraft.bone": "骨",
  "item.minecraft.bone_meal": "骨粉",
  "item.minecraft.book": "本",
  "item.minecraft.bordure_indented_banner_pattern": "山形波の縁取りの旗の模様",
  "item.minecraft.bow": "弓",
  "item.minecraft.bowl": "ボウル",
  "item.minecraft.bread": "パン",
  "item.minecraft.breeze_rod": "ブリーズロッド",
  "item.minecraft.breeze_spawn_egg": "ブリーズのスポーンエッグ",
  "item.minecraft.brewer_pottery_shard": "醸造家の壺の欠片",
  "item.minecraft.brewer_pottery_sherd": "醸造家の壺の欠片",
  "item.minecraft.brewing_stand": "醸造台",
  "item.minecraft.brick": "レンガ",
  "item.minecraft.brown_bundle": "茶色のバンドル",
  "item.minecraft.brown_dye": "茶色の染料",
  "item.minecraft.brown_egg": "茶色の卵",
  "item.minecraft.brown_harness": "茶色のハーネス",
  "item.minecraft.brush": "ブラシ",
  "item.minecraft.bucket": "バケツ",
  "item.minecraft.bundle": "バンドル",
  "item.minecraft.bundle.empty": "空",
  "item.minecraft.bundle.empty.description": "複数種類のアイテムを1スタック分まで一緒にしまうことができます",
  "item.minecraft.bundle.full": "満杯",
  "item.minecraft.bundle.fullness": "%s／%s",
  "item.minecraft.burn_pottery_shard": "炎の壺の欠片",
  "item.minecraft.burn_pottery_sherd": "炎の壺の欠片",
  "item.minecraft.camel_husk_spawn_egg": "ラクダハスクのスポーンエッグ",
  "item.minecraft.camel_spawn_egg": "ラクダのスポーンエッグ",
  "item.minecraft.carrot": "ニンジン",
  "item.minecraft.carrot_on_a_stick": "ニンジン付きの棒",
  "item.minecraft.cat_spawn_egg": "ネコのスポーンエッグ",
  "item.minecraft.cauldron": "大釜",
  "item.minecraft.cave_spider_spawn_egg": "洞窟グモのスポーンエッグ",
  "item.minecraft.chainmail_boots": "チェーンのブーツ",
  "item.minecraft.chainmail_chestplate": "チェーンのチェストプレート",
  "item.minecraft.chainmail_helmet": "チェーンのヘルメット",
  "item.minecraft.chainmail_leggings": "チェーンのレギンス",
  "item.minecraft.charcoal": "木炭",
  "item.minecraft.cherry_boat": "サクラのボート",
  "item.minecraft.cherry_chest_boat": "チェスト付きのサクラのボート",
  "item.minecraft.chest_minecart": "チェスト付きのトロッコ",
  "item.minecraft.chicken": "生の鶏肉",
  "item.minecraft.chicken_spawn_egg": "ニワトリのスポーンエッグ",
  "item.minecraft.chorus_fruit": "コーラスフルーツ",
  "item.minecraft.clay_ball": "粘土玉",
  "item.minecraft.clock": "時計",
  "item.minecraft.coal": "石炭",
  "item.minecraft.coast_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.coast_armor_trim_smithing_template.new": "海洋風の装飾",
  "item.minecraft.cocoa_beans": "カカオ豆",
  "item.minecraft.cod": "生鱈",
  "item.minecraft.cod_bucket": "タラ入りバケツ",
  "item.minecraft.cod_spawn_egg": "タラのスポーンエッグ",
  "item.minecraft.command_block_minecart": "コマンドブロック付きのトロッコ",
  "item.minecraft.compass": "コンパス",
  "item.minecraft.cooked_beef": "ステーキ",
  "item.minecraft.cooked_chicken": "焼き鳥",
  "item.minecraft.cooked_cod": "焼き鱈",
  "item.minecraft.cooked_mutton": "焼き羊肉",
  "item.minecraft.cooked_porkchop": "焼き豚",
  "item.minecraft.cooked_rabbit": "焼き兎肉",
  "item.minecraft.cooked_salmon": "焼き鮭",
  "item.minecraft.cookie": "クッキー",
  "item.minecraft.copper_axe": "銅の斧",
  "item.minecraft.copper_boots": "銅のブーツ",
  "item.minecraft.copper_chestplate": "銅のチェストプレート",
  "item.minecraft.copper_golem_spawn_egg": "カッパーゴーレムのスポーンエッグ",
  "item.minecraft.copper_helmet": "銅のヘルメット",
  "item.minecraft.copper_hoe": "銅のクワ",
  "item.minecraft.copper_horse_armor": "銅の馬鎧",
  "item.minecraft.copper_ingot": "銅インゴット",
  "item.minecraft.copper_leggings": "銅のレギンス",
  "item.minecraft.copper_nautilus_armor": "銅のオウムガイの鎧",
  "item.minecraft.copper_nugget": "銅塊",
  "item.minecraft.copper_pickaxe": "銅のツルハシ",
  "item.minecraft.copper_shovel": "銅のシャベル",
  "item.minecraft.copper_spear": "銅の槍",
  "item.minecraft.copper_sword": "銅の剣",
  "item.minecraft.cow_spawn_egg": "ウシのスポーンエッグ",
  "item.minecraft.creaking_spawn_egg": "クリーキングのスポーンエッグ",
  "item.minecraft.creeper_banner_pattern": "旗の模様",
  "item.minecraft.creeper_banner_pattern.desc": "クリーパー模様",
  "item.minecraft.creeper_banner_pattern.new": "クリーパーの旗の模様",
  "item.minecraft.creeper_spawn_egg": "クリーパーのスポーンエッグ",
  "item.minecraft.crossbow": "クロスボウ",
  "item.minecraft.crossbow.projectile": "発射物：",
  "item.minecraft.crossbow.projectile.multiple": "発射物：%2$s x %1$s",
  "item.minecraft.crossbow.projectile.single": "発射物：%s",
  "item.minecraft.cyan_bundle": "青緑色のバンドル",
  "item.minecraft.cyan_dye": "青緑色の染料",
  "item.minecraft.cyan_harness": "青緑色のハーネス",
  "item.minecraft.danger_pottery_shard": "脅威の壺の欠片",
  "item.minecraft.danger_pottery_sherd": "脅威の壺の欠片",
  "item.minecraft.dark_oak_boat": "ダークオークのボート",
  "item.minecraft.dark_oak_chest_boat": "チェスト付きのダークオークのボート",
  "item.minecraft.debug_stick": "デバッグ棒",
  "item.minecraft.debug_stick.empty": "%sはプロパティを持っていません",
  "item.minecraft.debug_stick.select": "「%s」を選択しました（%s）",
  "item.minecraft.debug_stick.update": "「%s」を%sに変更しました",
  "item.minecraft.diamond": "ダイヤモンド",
  "item.minecraft.diamond_axe": "ダイヤモンドの斧",
  "item.minecraft.diamond_boots": "ダイヤモンドのブーツ",
  "item.minecraft.diamond_chestplate": "ダイヤモンドのチェストプレート",
  "item.minecraft.diamond_helmet": "ダイヤモンドのヘルメット",
  "item.minecraft.diamond_hoe": "ダイヤモンドのクワ",
  "item.minecraft.diamond_horse_armor": "ダイヤモンドの馬鎧",
  "item.minecraft.diamond_leggings": "ダイヤモンドのレギンス",
  "item.minecraft.diamond_nautilus_armor": "ダイヤモンドのオウムガイの鎧",
  "item.minecraft.diamond_pickaxe": "ダイヤモンドのツルハシ",
  "item.minecraft.diamond_shovel": "ダイヤモンドのシャベル",
  "item.minecraft.diamond_spear": "ダイヤモンドの槍",
  "item.minecraft.diamond_sword": "ダイヤモンドの剣",
  "item.minecraft.disc_fragment_5": "レコードの破片",
  "item.minecraft.disc_fragment_5.desc": "レコード - 5",
  "item.minecraft.dolphin_spawn_egg": "イルカのスポーンエッグ",
  "item.minecraft.donkey_spawn_egg": "ロバのスポーンエッグ",
  "item.minecraft.dragon_breath": "ドラゴンブレス",
  "item.minecraft.dried_kelp": "乾燥した昆布",
  "item.minecraft.drowned_spawn_egg": "ドラウンドのスポーンエッグ",
  "item.minecraft.dune_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.dune_armor_trim_smithing_template.new": "砂丘風の装飾",
  "item.minecraft.echo_shard": "残響の欠片",
  "item.minecraft.egg": "卵",
  "item.minecraft.elder_guardian_spawn_egg": "エルダーガーディアンのスポーンエッグ",
  "item.minecraft.elytra": "エリトラ",
  "item.minecraft.emerald": "エメラルド",
  "item.minecraft.enchanted_book": "エンチャントの本",
  "item.minecraft.enchanted_golden_apple": "エンチャントされた金のリンゴ",
  "item.minecraft.end_crystal": "エンドクリスタル",
  "item.minecraft.ender_dragon_spawn_egg": "エンダードラゴンのスポーンエッグ",
  "item.minecraft.ender_eye": "エンダーアイ",
  "item.minecraft.ender_pearl": "エンダーパール",
  "item.minecraft.enderman_spawn_egg": "エンダーマンのスポーンエッグ",
  "item.minecraft.endermite_spawn_egg": "エンダーマイトのスポーンエッグ",
  "item.minecraft.evoker_spawn_egg": "エヴォーカーのスポーンエッグ",
  "item.minecraft.experience_bottle": "エンチャントの瓶",
  "item.minecraft.explorer_pottery_shard": "探検家の壺の欠片",
  "item.minecraft.explorer_pottery_sherd": "探検家の壺の欠片",
  "item.minecraft.eye_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.eye_armor_trim_smithing_template.new": "エンダーアイ風の装飾",
  "item.minecraft.feather": "羽根",
  "item.minecraft.fermented_spider_eye": "発酵したクモの目",
  "item.minecraft.field_masoned_banner_pattern": "レンガの旗の模様",
  "item.minecraft.filled_map": "地図",
  "item.minecraft.fire_charge": "ファイヤーチャージ",
  "item.minecraft.firework_rocket": "ロケット花火",
  "item.minecraft.firework_rocket.flight": "飛翔時間：",
  "item.minecraft.firework_rocket.multiple_stars": "%2$s x %1$s",
  "item.minecraft.firework_rocket.single_star": "%s",
  "item.minecraft.firework_star": "花火の星",
  "item.minecraft.firework_star.black": "黒色",
  "item.minecraft.firework_star.blue": "青色",
  "item.minecraft.firework_star.brown": "茶色",
  "item.minecraft.firework_star.custom_color": "カスタム",
  "item.minecraft.firework_star.cyan": "青緑色",
  "item.minecraft.firework_star.fade_to": "色変化：",
  "item.minecraft.firework_star.flicker": "点滅",
  "item.minecraft.firework_star.gray": "灰色",
  "item.minecraft.firework_star.green": "緑色",
  "item.minecraft.firework_star.light_blue": "空色",
  "item.minecraft.firework_star.light_gray": "薄灰色",
  "item.minecraft.firework_star.lime": "黄緑色",
  "item.minecraft.firework_star.magenta": "赤紫色",
  "item.minecraft.firework_star.orange": "橙色",
  "item.minecraft.firework_star.pink": "桃色",
  "item.minecraft.firework_star.purple": "紫色",
  "item.minecraft.firework_star.red": "赤色",
  "item.minecraft.firework_star.shape": "不明な形状",
  "item.minecraft.firework_star.shape.burst": "破裂",
  "item.minecraft.firework_star.shape.creeper": "クリーパー型",
  "item.minecraft.firework_star.shape.large_ball": "大玉",
  "item.minecraft.firework_star.shape.small_ball": "小玉",
  "item.minecraft.firework_star.shape.star": "星型",
  "item.minecraft.firework_star.trail": "流星",
  "item.minecraft.firework_star.white": "白色",
  "item.minecraft.firework_star.yellow": "黄色",
  "item.minecraft.fishing_rod": "釣竿",
  "item.minecraft.flint": "火打石",
  "item.minecraft.flint_and_steel": "火打石と打ち金",
  "item.minecraft.flow_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.flow_armor_trim_smithing_template.new": "旋風の装飾",
  "item.minecraft.flow_banner_pattern": "旗の模様",
  "item.minecraft.flow_banner_pattern.desc": "渦巻き模様",
  "item.minecraft.flow_banner_pattern.new": "渦巻きの旗の模様",
  "item.minecraft.flow_pottery_sherd": "渦巻きの壺の欠片",
  "item.minecraft.flower_banner_pattern": "旗の模様",
  "item.minecraft.flower_banner_pattern.desc": "花模様",
  "item.minecraft.flower_banner_pattern.new": "花の旗の模様",
  "item.minecraft.flower_pot": "植木鉢",
  "item.minecraft.fox_spawn_egg": "キツネのスポーンエッグ",
  "item.minecraft.friend_pottery_shard": "友の壺の欠片",
  "item.minecraft.friend_pottery_sherd": "友の壺の欠片",
  "item.minecraft.frog_spawn_egg": "カエルのスポーンエッグ",
  "item.minecraft.furnace_minecart": "かまど付きのトロッコ",
  "item.minecraft.ghast_spawn_egg": "ガストのスポーンエッグ",
  "item.minecraft.ghast_tear": "ガストの涙",
  "item.minecraft.glass_bottle": "ガラス瓶",
  "item.minecraft.glistering_melon_slice": "きらめくスイカの薄切り",
  "item.minecraft.globe_banner_pattern": "旗の模様",
  "item.minecraft.globe_banner_pattern.desc": "地球の模様",
  "item.minecraft.globe_banner_pattern.new": "地球の旗の模様",
  "item.minecraft.glow_berries": "グロウベリー",
  "item.minecraft.glow_ink_sac": "輝くイカスミ",
  "item.minecraft.glow_item_frame": "輝く額縁",
  "item.minecraft.glow_squid_spawn_egg": "ヒカリイカのスポーンエッグ",
  "item.minecraft.glowstone_dust": "グロウストーンダスト",
  "item.minecraft.goat_horn": "ヤギの角笛",
  "item.minecraft.goat_spawn_egg": "ヤギのスポーンエッグ",
  "item.minecraft.gold_ingot": "金インゴット",
  "item.minecraft.gold_nugget": "金塊",
  "item.minecraft.golden_apple": "金のリンゴ",
  "item.minecraft.golden_axe": "金の斧",
  "item.minecraft.golden_boots": "金のブーツ",
  "item.minecraft.golden_carrot": "金のニンジン",
  "item.minecraft.golden_chestplate": "金のチェストプレート",
  "item.minecraft.golden_helmet": "金のヘルメット",
  "item.minecraft.golden_hoe": "金のクワ",
  "item.minecraft.golden_horse_armor": "金の馬鎧",
  "item.minecraft.golden_leggings": "金のレギンス",
  "item.minecraft.golden_nautilus_armor": "金のオウムガイの鎧",
  "item.minecraft.golden_pickaxe": "金のツルハシ",
  "item.minecraft.golden_shovel": "金のシャベル",
  "item.minecraft.golden_spear": "金の槍",
  "item.minecraft.golden_sword": "金の剣",
  "item.minecraft.gray_bundle": "灰色のバンドル",
  "item.minecraft.gray_dye": "灰色の染料",
  "item.minecraft.gray_harness": "灰色のハーネス",
  "item.minecraft.green_bundle": "緑色のバンドル",
  "item.minecraft.green_dye": "緑色の染料",
  "item.minecraft.green_harness": "緑色のハーネス",
  "item.minecraft.guardian_spawn_egg": "ガーディアンのスポーンエッグ",
  "item.minecraft.gunpowder": "火薬",
  "item.minecraft.guster_banner_pattern": "旗の模様",
  "item.minecraft.guster_banner_pattern.desc": "風巻く者の模様",
  "item.minecraft.guster_banner_pattern.new": "風巻く者の旗の模様",
  "item.minecraft.guster_pottery_sherd": "風巻く者の壺の欠片",
  "item.minecraft.happy_ghast_spawn_egg": "ハッピーガストのスポーンエッグ",
  "item.minecraft.harness": "ハーネス",
  "item.minecraft.heart_of_the_sea": "海洋の心",
  "item.minecraft.heart_pottery_shard": "心の壺の欠片",
  "item.minecraft.heart_pottery_sherd": "心の壺の欠片",
  "item.minecraft.heartbreak_pottery_shard": "傷心の壺の欠片",
  "item.minecraft.heartbreak_pottery_sherd": "傷心の壺の欠片",
  "item.minecraft.hoglin_spawn_egg": "ホグリンのスポーンエッグ",
  "item.minecraft.honey_bottle": "ハチミツ入りの瓶",
  "item.minecraft.honeycomb": "ハニカム",
  "item.minecraft.hopper_minecart": "ホッパー付きのトロッコ",
  "item.minecraft.horse_spawn_egg": "ウマのスポーンエッグ",
  "item.minecraft.host_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.host_armor_trim_smithing_template.new": "主人風の装飾",
  "item.minecraft.howl_pottery_shard": "遠吠えの壺の欠片",
  "item.minecraft.howl_pottery_sherd": "遠吠えの壺の欠片",
  "item.minecraft.husk_spawn_egg": "ハスクのスポーンエッグ",
  "item.minecraft.ink_sac": "イカスミ",
  "item.minecraft.iron_axe": "鉄の斧",
  "item.minecraft.iron_boots": "鉄のブーツ",
  "item.minecraft.iron_chestplate": "鉄のチェストプレート",
  "item.minecraft.iron_golem_spawn_egg": "アイアンゴーレムのスポーンエッグ",
  "item.minecraft.iron_helmet": "鉄のヘルメット",
  "item.minecraft.iron_hoe": "鉄のクワ",
  "item.minecraft.iron_horse_armor": "鉄の馬鎧",
  "item.minecraft.iron_ingot": "鉄インゴット",
  "item.minecraft.iron_leggings": "鉄のレギンス",
  "item.minecraft.iron_nautilus_armor": "鉄のオウムガイの鎧",
  "item.minecraft.iron_nugget": "鉄塊",
  "item.minecraft.iron_pickaxe": "鉄のツルハシ",
  "item.minecraft.iron_shovel": "鉄のシャベル",
  "item.minecraft.iron_spear": "鉄の槍",
  "item.minecraft.iron_sword": "鉄の剣",
  "item.minecraft.item_frame": "額縁",
  "item.minecraft.jungle_boat": "ジャングルのボート",
  "item.minecraft.jungle_chest_boat": "チェスト付きのジャングルのボート",
  "item.minecraft.knowledge_book": "知恵の本",
  "item.minecraft.lapis_lazuli": "ラピスラズリ",
  "item.minecraft.lava_bucket": "溶岩入りバケツ",
  "item.minecraft.lead": "リード",
  "item.minecraft.leather": "革",
  "item.minecraft.leather_boots": "革のブーツ",
  "item.minecraft.leather_chestplate": "革の上着",
  "item.minecraft.leather_helmet": "革の帽子",
  "item.minecraft.leather_horse_armor": "革の馬鎧",
  "item.minecraft.leather_leggings": "革のズボン",
  "item.minecraft.light_blue_bundle": "空色のバンドル",
  "item.minecraft.light_blue_dye": "空色の染料",
  "item.minecraft.light_blue_harness": "空色のハーネス",
  "item.minecraft.light_gray_bundle": "薄灰色のバンドル",
  "item.minecraft.light_gray_dye": "薄灰色の染料",
  "item.minecraft.light_gray_harness": "薄灰色のハーネス",
  "item.minecraft.lime_bundle": "黄緑色のバンドル",
  "item.minecraft.lime_dye": "黄緑色の染料",
  "item.minecraft.lime_harness": "黄緑色のハーネス",
  "item.minecraft.lingering_potion": "残留ポーション",
  "item.minecraft.lingering_potion.effect.awkward": "奇妙な残留ポーション",
  "item.minecraft.lingering_potion.effect.empty": "クラフト不可能な残留ポーション",
  "item.minecraft.lingering_potion.effect.fire_resistance": "耐火の残留ポーション",
  "item.minecraft.lingering_potion.effect.harming": "負傷の残留ポーション",
  "item.minecraft.lingering_potion.effect.healing": "治癒の残留ポーション",
  "item.minecraft.lingering_potion.effect.infested": "虫食いの残留ポーション",
  "item.minecraft.lingering_potion.effect.invisibility": "透明化の残留ポーション",
  "item.minecraft.lingering_potion.effect.leaping": "跳躍の残留ポーション",
  "item.minecraft.lingering_potion.effect.levitation": "浮遊の残留ポーション",
  "item.minecraft.lingering_potion.effect.luck": "幸運の残留ポーション",
  "item.minecraft.lingering_potion.effect.mundane": "ありふれた残留ポーション",
  "item.minecraft.lingering_potion.effect.night_vision": "暗視の残留ポーション",
  "item.minecraft.lingering_potion.effect.oozing": "滲出の残留ポーション",
  "item.minecraft.lingering_potion.effect.poison": "毒の残留ポーション",
  "item.minecraft.lingering_potion.effect.regeneration": "再生の残留ポーション",
  "item.minecraft.lingering_potion.effect.slow_falling": "低速落下の残留ポーション",
  "item.minecraft.lingering_potion.effect.slowness": "鈍化の残留ポーション",
  "item.minecraft.lingering_potion.effect.strength": "力の残留ポーション",
  "item.minecraft.lingering_potion.effect.swiftness": "俊敏の残留ポーション",
  "item.minecraft.lingering_potion.effect.thick": "濃厚な残留ポーション",
  "item.minecraft.lingering_potion.effect.turtle_master": "タートルマスターの残留ポーション",
  "item.minecraft.lingering_potion.effect.water": "水入り残留瓶",
  "item.minecraft.lingering_potion.effect.water_breathing": "水中呼吸の残留ポーション",
  "item.minecraft.lingering_potion.effect.weakness": "弱化の残留ポーション",
  "item.minecraft.lingering_potion.effect.weaving": "巣張りの残留ポーション",
  "item.minecraft.lingering_potion.effect.wind_charged": "蓄風の残留ポーション",
  "item.minecraft.llama_spawn_egg": "ラマのスポーンエッグ",
  "item.minecraft.lodestone_compass": "ロードストーンコンパス",
  "item.minecraft.mace": "メイス",
  "item.minecraft.magenta_bundle": "赤紫色のバンドル",
  "item.minecraft.magenta_dye": "赤紫色の染料",
  "item.minecraft.magenta_harness": "赤紫色のハーネス",
  "item.minecraft.magma_cream": "マグマクリーム",
  "item.minecraft.magma_cube_spawn_egg": "マグマキューブのスポーンエッグ",
  "item.minecraft.mangrove_boat": "マングローブのボート",
  "item.minecraft.mangrove_chest_boat": "チェスト付きのマングローブのボート",
  "item.minecraft.map": "白紙の地図",
  "item.minecraft.melon_seeds": "スイカの種",
  "item.minecraft.melon_slice": "スイカの薄切り",
  "item.minecraft.milk_bucket": "ミルク入りバケツ",
  "item.minecraft.minecart": "トロッコ",
  "item.minecraft.miner_pottery_shard": "鉱夫の壺の欠片",
  "item.minecraft.miner_pottery_sherd": "鉱夫の壺の欠片",
  "item.minecraft.mojang_banner_pattern": "旗の模様",
  "item.minecraft.mojang_banner_pattern.desc": "何かの模様",
  "item.minecraft.mojang_banner_pattern.new": "何かの旗の模様",
  "item.minecraft.mooshroom_spawn_egg": "ムーシュルームのスポーンエッグ",
  "item.minecraft.mourner_pottery_shard": "哀悼者の壺の欠片",
  "item.minecraft.mourner_pottery_sherd": "哀悼者の壺の欠片",
  "item.minecraft.mule_spawn_egg": "ラバのスポーンエッグ",
  "item.minecraft.mushroom_stew": "キノコシチュー",
  "item.minecraft.music_disc_11": "レコード",
  "item.minecraft.music_disc_11.desc": "C418 - 11",
  "item.minecraft.music_disc_13": "レコード",
  "item.minecraft.music_disc_13.desc": "C418 - 13",
  "item.minecraft.music_disc_5": "レコード",
  "item.minecraft.music_disc_5.desc": "Samuel Åberg - 5",
  "item.minecraft.music_disc_blocks": "レコード",
  "item.minecraft.music_disc_blocks.desc": "C418 - blocks",
  "item.minecraft.music_disc_cat": "レコード",
  "item.minecraft.music_disc_cat.desc": "C418 - cat",
  "item.minecraft.music_disc_chirp": "レコード",
  "item.minecraft.music_disc_chirp.desc": "C418 - chirp",
  "item.minecraft.music_disc_creator": "レコード",
  "item.minecraft.music_disc_creator.desc": "Lena Raine - Creator",
  "item.minecraft.music_disc_creator_music_box": "レコード",
  "item.minecraft.music_disc_creator_music_box.desc": "Lena Raine - Creator（オルゴール）",
  "item.minecraft.music_disc_far": "レコード",
  "item.minecraft.music_disc_far.desc": "C418 - far",
  "item.minecraft.music_disc_lava_chicken": "レコード",
  "item.minecraft.music_disc_lava_chicken.desc": "Hyper Potions - Lava Chicken",
  "item.minecraft.music_disc_mall": "レコード",
  "item.minecraft.music_disc_mall.desc": "C418 - mall",
  "item.minecraft.music_disc_mellohi": "レコード",
  "item.minecraft.music_disc_mellohi.desc": "C418 - mellohi",
  "item.minecraft.music_disc_otherside": "レコード",
  "item.minecraft.music_disc_otherside.desc": "Lena Raine - otherside",
  "item.minecraft.music_disc_pigstep": "レコード",
  "item.minecraft.music_disc_pigstep.desc": "Lena Raine - Pigstep",
  "item.minecraft.music_disc_precipice": "レコード",
  "item.minecraft.music_disc_precipice.desc": "Aaron Cherof - Precipice",
  "item.minecraft.music_disc_relic": "レコード",
  "item.minecraft.music_disc_relic.desc": "Aaron Cherof - Relic",
  "item.minecraft.music_disc_stal": "レコード",
  "item.minecraft.music_disc_stal.desc": "C418 - stal",
  "item.minecraft.music_disc_strad": "レコード",
  "item.minecraft.music_disc_strad.desc": "C418 - strad",
  "item.minecraft.music_disc_tears": "レコード",
  "item.minecraft.music_disc_tears.desc": "Amos Roddy - Tears",
  "item.minecraft.music_disc_wait": "レコード",
  "item.minecraft.music_disc_wait.desc": "C418 - wait",
  "item.minecraft.music_disc_ward": "レコード",
  "item.minecraft.music_disc_ward.desc": "C418 - ward",
  "item.minecraft.mutton": "生の羊肉",
  "item.minecraft.name_tag": "名札",
  "item.minecraft.nautilus_shell": "オウムガイの殻",
  "item.minecraft.nautilus_spawn_egg": "オウムガイのスポーンエッグ",
  "item.minecraft.nether_brick": "ネザーレンガ",
  "item.minecraft.nether_star": "ネザースター",
  "item.minecraft.nether_wart": "ネザーウォート",
  "item.minecraft.netherite_axe": "ネザライトの斧",
  "item.minecraft.netherite_boots": "ネザライトのブーツ",
  "item.minecraft.netherite_chestplate": "ネザライトのチェストプレート",
  "item.minecraft.netherite_helmet": "ネザライトのヘルメット",
  "item.minecraft.netherite_hoe": "ネザライトのクワ",
  "item.minecraft.netherite_horse_armor": "ネザライトの馬鎧",
  "item.minecraft.netherite_ingot": "ネザライトインゴット",
  "item.minecraft.netherite_leggings": "ネザライトのレギンス",
  "item.minecraft.netherite_nautilus_armor": "ネザライトのオウムガイの鎧",
  "item.minecraft.netherite_pickaxe": "ネザライトのツルハシ",
  "item.minecraft.netherite_scrap": "ネザライトの欠片",
  "item.minecraft.netherite_shovel": "ネザライトのシャベル",
  "item.minecraft.netherite_spear": "ネザライトの槍",
  "item.minecraft.netherite_sword": "ネザライトの剣",
  "item.minecraft.netherite_upgrade_smithing_template": "鍛冶型",
  "item.minecraft.netherite_upgrade_smithing_template.new": "ネザライト強化",
  "item.minecraft.oak_boat": "オークのボート",
  "item.minecraft.oak_chest_boat": "チェスト付きのオークのボート",
  "item.minecraft.ocelot_spawn_egg": "ヤマネコのスポーンエッグ",
  "item.minecraft.ominous_bottle": "不吉な瓶",
  "item.minecraft.ominous_trial_key": "不吉な試練の鍵",
  "item.minecraft.orange_bundle": "橙色のバンドル",
  "item.minecraft.orange_dye": "橙色の染料",
  "item.minecraft.orange_harness": "橙色のハーネス",
  "item.minecraft.painting": "絵画",
  "item.minecraft.pale_oak_boat": "ペールオークのボート",
  "item.minecraft.pale_oak_chest_boat": "チェスト付きのペールオークのボート",
  "item.minecraft.panda_spawn_egg": "パンダのスポーンエッグ",
  "item.minecraft.paper": "紙",
  "item.minecraft.parched_spawn_egg": "パーチドのスポーンエッグ",
  "item.minecraft.parrot_spawn_egg": "オウムのスポーンエッグ",
  "item.minecraft.phantom_membrane": "ファントムの皮膜",
  "item.minecraft.phantom_spawn_egg": "ファントムのスポーンエッグ",
  "item.minecraft.pig_spawn_egg": "ブタのスポーンエッグ",
  "item.minecraft.piglin_banner_pattern": "旗の模様",
  "item.minecraft.piglin_banner_pattern.desc": "ブタの鼻の模様",
  "item.minecraft.piglin_banner_pattern.new": "ブタの鼻の旗の模様",
  "item.minecraft.piglin_brute_spawn_egg": "ピグリンブルートのスポーンエッグ",
  "item.minecraft.piglin_spawn_egg": "ピグリンのスポーンエッグ",
  "item.minecraft.pillager_spawn_egg": "ピリジャーのスポーンエッグ",
  "item.minecraft.pink_bundle": "桃色のバンドル",
  "item.minecraft.pink_dye": "桃色の染料",
  "item.minecraft.pink_harness": "桃色のハーネス",
  "item.minecraft.pitcher_plant": "ウツボカズラ",
  "item.minecraft.pitcher_pod": "ウツボカズラのさや",
  "item.minecraft.plenty_pottery_shard": "富の壺の欠片",
  "item.minecraft.plenty_pottery_sherd": "富の壺の欠片",
  "item.minecraft.poisonous_potato": "青くなったジャガイモ",
  "item.minecraft.polar_bear_spawn_egg": "シロクマのスポーンエッグ",
  "item.minecraft.popped_chorus_fruit": "焼いたコーラスフルーツ",
  "item.minecraft.porkchop": "生の豚肉",
  "item.minecraft.potato": "ジャガイモ",
  "item.minecraft.potion": "ポーション",
  "item.minecraft.potion.effect.awkward": "奇妙なポーション",
  "item.minecraft.potion.effect.empty": "クラフト不可能なポーション",
  "item.minecraft.potion.effect.fire_resistance": "耐火のポーション",
  "item.minecraft.potion.effect.harming": "負傷のポーション",
  "item.minecraft.potion.effect.healing": "治癒のポーション",
  "item.minecraft.potion.effect.infested": "虫食いのポーション",
  "item.minecraft.potion.effect.invisibility": "透明化のポーション",
  "item.minecraft.potion.effect.leaping": "跳躍のポーション",
  "item.minecraft.potion.effect.levitation": "浮遊のポーション",
  "item.minecraft.potion.effect.luck": "幸運のポーション",
  "item.minecraft.potion.effect.mundane": "ありふれたポーション",
  "item.minecraft.potion.effect.night_vision": "暗視のポーション",
  "item.minecraft.potion.effect.oozing": "滲出のポーション",
  "item.minecraft.potion.effect.poison": "毒のポーション",
  "item.minecraft.potion.effect.regeneration": "再生のポーション",
  "item.minecraft.potion.effect.slow_falling": "低速落下のポーション",
  "item.minecraft.potion.effect.slowness": "鈍化のポーション",
  "item.minecraft.potion.effect.strength": "力のポーション",
  "item.minecraft.potion.effect.swiftness": "俊敏のポーション",
  "item.minecraft.potion.effect.thick": "濃厚なポーション",
  "item.minecraft.potion.effect.turtle_master": "タートルマスターのポーション",
  "item.minecraft.potion.effect.water": "水入り瓶",
  "item.minecraft.potion.effect.water_breathing": "水中呼吸のポーション",
  "item.minecraft.potion.effect.weakness": "弱化のポーション",
  "item.minecraft.potion.effect.weaving": "巣張りのポーション",
  "item.minecraft.potion.effect.wind_charged": "蓄風のポーション",
  "item.minecraft.pottery_shard_archer": "射手の壺の欠片",
  "item.minecraft.pottery_shard_arms_up": "両腕を上げた人の壺の欠片",
  "item.minecraft.pottery_shard_prize": "宝物の壺の欠片",
  "item.minecraft.pottery_shard_skull": "頭蓋骨の壺の欠片",
  "item.minecraft.powder_snow_bucket": "粉雪入りバケツ",
  "item.minecraft.prismarine_crystals": "プリズマリンクリスタル",
  "item.minecraft.prismarine_shard": "プリズマリンの欠片",
  "item.minecraft.prize_pottery_shard": "宝物の壺の欠片",
  "item.minecraft.prize_pottery_sherd": "宝物の壺の欠片",
  "item.minecraft.pufferfish": "フグ",
  "item.minecraft.pufferfish_bucket": "フグ入りバケツ",
  "item.minecraft.pufferfish_spawn_egg": "フグのスポーンエッグ",
  "item.minecraft.pumpkin_pie": "パンプキンパイ",
  "item.minecraft.pumpkin_seeds": "カボチャの種",
  "item.minecraft.purple_bundle": "紫色のバンドル",
  "item.minecraft.purple_dye": "紫色の染料",
  "item.minecraft.purple_harness": "紫色のハーネス",
  "item.minecraft.quartz": "ネザークォーツ",
  "item.minecraft.rabbit": "生の兎肉",
  "item.minecraft.rabbit_foot": "ウサギの足",
  "item.minecraft.rabbit_hide": "ウサギの皮",
  "item.minecraft.rabbit_spawn_egg": "ウサギのスポーンエッグ",
  "item.minecraft.rabbit_stew": "ウサギシチュー",
  "item.minecraft.raiser_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.raiser_armor_trim_smithing_template.new": "牧者風の装飾",
  "item.minecraft.ravager_spawn_egg": "ラヴェジャーのスポーンエッグ",
  "item.minecraft.raw_copper": "銅の原石",
  "item.minecraft.raw_gold": "金の原石",
  "item.minecraft.raw_iron": "鉄の原石",
  "item.minecraft.recovery_compass": "リカバリーコンパス",
  "item.minecraft.red_bundle": "赤色のバンドル",
  "item.minecraft.red_dye": "赤色の染料",
  "item.minecraft.red_harness": "赤色のハーネス",
  "item.minecraft.redstone": "レッドストーンダスト",
  "item.minecraft.resin_brick": "樹脂レンガ",
  "item.minecraft.resin_clump": "樹脂の塊",
  "item.minecraft.rib_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.rib_armor_trim_smithing_template.new": "あばら模様の装飾",
  "item.minecraft.rotten_flesh": "腐った肉",
  "item.minecraft.saddle": "鞍",
  "item.minecraft.salmon": "生鮭",
  "item.minecraft.salmon_bucket": "サケ入りバケツ",
  "item.minecraft.salmon_spawn_egg": "サケのスポーンエッグ",
  "item.minecraft.scrape_pottery_sherd": "斧の壺の欠片",
  "item.minecraft.scute": "カメのウロコ",
  "item.minecraft.sentry_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.sentry_armor_trim_smithing_template.new": "略奪者風の装飾",
  "item.minecraft.shaper_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.shaper_armor_trim_smithing_template.new": "職人風の装飾",
  "item.minecraft.sheaf_pottery_shard": "麦束の壺の欠片",
  "item.minecraft.sheaf_pottery_sherd": "麦束の壺の欠片",
  "item.minecraft.shears": "ハサミ",
  "item.minecraft.sheep_spawn_egg": "ヒツジのスポーンエッグ",
  "item.minecraft.shelter_pottery_shard": "木陰の壺の欠片",
  "item.minecraft.shelter_pottery_sherd": "木陰の壺の欠片",
  "item.minecraft.shield": "盾",
  "item.minecraft.shield.black": "黒色の盾",
  "item.minecraft.shield.blue": "青色の盾",
  "item.minecraft.shield.brown": "茶色の盾",
  "item.minecraft.shield.cyan": "青緑色の盾",
  "item.minecraft.shield.gray": "灰色の盾",
  "item.minecraft.shield.green": "緑色の盾",
  "item.minecraft.shield.light_blue": "空色の盾",
  "item.minecraft.shield.light_gray": "薄灰色の盾",
  "item.minecraft.shield.lime": "黄緑色の盾",
  "item.minecraft.shield.magenta": "赤紫色の盾",
  "item.minecraft.shield.orange": "橙色の盾",
  "item.minecraft.shield.pink": "桃色の盾",
  "item.minecraft.shield.purple": "紫色の盾",
  "item.minecraft.shield.red": "赤色の盾",
  "item.minecraft.shield.white": "白色の盾",
  "item.minecraft.shield.yellow": "黄色の盾",
  "item.minecraft.shulker_shell": "シュルカーの殻",
  "item.minecraft.shulker_spawn_egg": "シュルカーのスポーンエッグ",
  "item.minecraft.sign": "看板",
  "item.minecraft.silence_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.silence_armor_trim_smithing_template.new": "静寂の装飾",
  "item.minecraft.silverfish_spawn_egg": "シルバーフィッシュのスポーンエッグ",
  "item.minecraft.skeleton_horse_spawn_egg": "スケルトンホースのスポーンエッグ",
  "item.minecraft.skeleton_spawn_egg": "スケルトンのスポーンエッグ",
  "item.minecraft.skull_banner_pattern": "旗の模様",
  "item.minecraft.skull_banner_pattern.desc": "骸骨模様",
  "item.minecraft.skull_banner_pattern.new": "骸骨の旗の模様",
  "item.minecraft.skull_pottery_shard": "頭蓋骨の壺の欠片",
  "item.minecraft.skull_pottery_sherd": "頭蓋骨の壺の欠片",
  "item.minecraft.slime_ball": "スライムボール",
  "item.minecraft.slime_spawn_egg": "スライムのスポーンエッグ",
  "item.minecraft.smithing_template": "鍛冶型",
  "item.minecraft.smithing_template.applies_to": "適用先：",
  "item.minecraft.smithing_template.armor_trim.additions_slot_description": "インゴットもしくは鉱物を置いてください",
  "item.minecraft.smithing_template.armor_trim.applies_to": "防具",
  "item.minecraft.smithing_template.armor_trim.base_slot_description": "防具を置いてください",
  "item.minecraft.smithing_template.armor_trim.ingredients": "インゴットや鉱物",
  "item.minecraft.smithing_template.ingredients": "材料：",
  "item.minecraft.smithing_template.netherite_upgrade.additions_slot_description": "ネザライトインゴットを置いてください",
  "item.minecraft.smithing_template.netherite_upgrade.applies_to": "ダイヤモンドの装備品",
  "item.minecraft.smithing_template.netherite_upgrade.base_slot_description": "ダイヤモンド製の防具、武器、道具を置いてください",
  "item.minecraft.smithing_template.netherite_upgrade.ingredients": "ネザライトインゴット",
  "item.minecraft.smithing_template.upgrade": "強化：",
  "item.minecraft.sniffer_spawn_egg": "スニッファーのスポーンエッグ",
  "item.minecraft.snort_pottery_shard": "鼻を鳴らす動物の壺の欠片",
  "item.minecraft.snort_pottery_sherd": "鼻を鳴らす動物の壺の欠片",
  "item.minecraft.snout_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.snout_armor_trim_smithing_template.new": "ブタの鼻風の装飾",
  "item.minecraft.snow_golem_spawn_egg": "スノウゴーレムのスポーンエッグ",
  "item.minecraft.snowball": "雪玉",
  "item.minecraft.spectral_arrow": "光の矢",
  "item.minecraft.spider_eye": "クモの目",
  "item.minecraft.spider_spawn_egg": "クモのスポーンエッグ",
  "item.minecraft.spire_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.spire_armor_trim_smithing_template.new": "尖塔風の装飾",
  "item.minecraft.splash_potion": "スプラッシュポーション",
  "item.minecraft.splash_potion.effect.awkward": "奇妙なスプラッシュポーション",
  "item.minecraft.splash_potion.effect.empty": "クラフト不可能なスプラッシュポーション",
  "item.minecraft.splash_potion.effect.fire_resistance": "耐火のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.harming": "負傷のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.healing": "治癒のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.infested": "虫食いのスプラッシュポーション",
  "item.minecraft.splash_potion.effect.invisibility": "透明化のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.leaping": "跳躍のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.levitation": "浮遊のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.luck": "幸運のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.mundane": "ありふれたスプラッシュポーション",
  "item.minecraft.splash_potion.effect.night_vision": "暗視のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.oozing": "滲出のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.poison": "毒のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.regeneration": "再生のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.slow_falling": "低速落下のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.slowness": "鈍化のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.strength": "力のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.swiftness": "俊敏のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.thick": "濃厚なスプラッシュポーション",
  "item.minecraft.splash_potion.effect.turtle_master": "タートルマスターのスプラッシュポーション",
  "item.minecraft.splash_potion.effect.water": "水入りスプラッシュ瓶",
  "item.minecraft.splash_potion.effect.water_breathing": "水中呼吸のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.weakness": "弱化のスプラッシュポーション",
  "item.minecraft.splash_potion.effect.weaving": "巣張りのスプラッシュポーション",
  "item.minecraft.splash_potion.effect.wind_charged": "蓄風のスプラッシュポーション",
  "item.minecraft.spruce_boat": "トウヒのボート",
  "item.minecraft.spruce_chest_boat": "チェスト付きのトウヒのボート",
  "item.minecraft.spyglass": "望遠鏡",
  "item.minecraft.squid_spawn_egg": "イカのスポーンエッグ",
  "item.minecraft.stick": "棒",
  "item.minecraft.stone_axe": "石の斧",
  "item.minecraft.stone_hoe": "石のクワ",
  "item.minecraft.stone_pickaxe": "石のツルハシ",
  "item.minecraft.stone_shovel": "石のシャベル",
  "item.minecraft.stone_spear": "石の槍",
  "item.minecraft.stone_sword": "石の剣",
  "item.minecraft.stray_spawn_egg": "ストレイのスポーンエッグ",
  "item.minecraft.strider_spawn_egg": "ストライダーのスポーンエッグ",
  "item.minecraft.string": "糸",
  "item.minecraft.sugar": "砂糖",
  "item.minecraft.suspicious_stew": "怪しげなシチュー",
  "item.minecraft.sweet_berries": "スイートベリー",
  "item.minecraft.tadpole_bucket": "オタマジャクシ入りバケツ",
  "item.minecraft.tadpole_spawn_egg": "オタマジャクシのスポーンエッグ",
  "item.minecraft.tide_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.tide_armor_trim_smithing_template.new": "潮流風の装飾",
  "item.minecraft.tipped_arrow": "効能付きの矢",
  "item.minecraft.tipped_arrow.effect.awkward": "奇妙な矢",
  "item.minecraft.tipped_arrow.effect.empty": "クラフト不可能な効能付きの矢",
  "item.minecraft.tipped_arrow.effect.fire_resistance": "耐火の矢",
  "item.minecraft.tipped_arrow.effect.harming": "負傷の矢",
  "item.minecraft.tipped_arrow.effect.healing": "治癒の矢",
  "item.minecraft.tipped_arrow.effect.infested": "虫食いの矢",
  "item.minecraft.tipped_arrow.effect.invisibility": "透明化の矢",
  "item.minecraft.tipped_arrow.effect.leaping": "跳躍の矢",
  "item.minecraft.tipped_arrow.effect.levitation": "浮遊の矢",
  "item.minecraft.tipped_arrow.effect.luck": "幸運の矢",
  "item.minecraft.tipped_arrow.effect.mundane": "ありふれた矢",
  "item.minecraft.tipped_arrow.effect.night_vision": "暗視の矢",
  "item.minecraft.tipped_arrow.effect.oozing": "滲出の矢",
  "item.minecraft.tipped_arrow.effect.poison": "毒の矢",
  "item.minecraft.tipped_arrow.effect.regeneration": "再生の矢",
  "item.minecraft.tipped_arrow.effect.slow_falling": "低速落下の矢",
  "item.minecraft.tipped_arrow.effect.slowness": "鈍化の矢",
  "item.minecraft.tipped_arrow.effect.strength": "力の矢",
  "item.minecraft.tipped_arrow.effect.swiftness": "俊敏の矢",
  "item.minecraft.tipped_arrow.effect.thick": "濃厚な矢",
  "item.minecraft.tipped_arrow.effect.turtle_master": "タートルマスターの矢",
  "item.minecraft.tipped_arrow.effect.water": "水の矢",
  "item.minecraft.tipped_arrow.effect.water_breathing": "水中呼吸の矢",
  "item.minecraft.tipped_arrow.effect.weakness": "弱化の矢",
  "item.minecraft.tipped_arrow.effect.weaving": "巣張りの矢",
  "item.minecraft.tipped_arrow.effect.wind_charged": "蓄風の矢",
  "item.minecraft.tnt_minecart": "TNT付きのトロッコ",
  "item.minecraft.torchflower_seeds": "トーチフラワーの種",
  "item.minecraft.totem_of_undying": "不死のトーテム",
  "item.minecraft.trader_llama_spawn_egg": "商人のラマのスポーンエッグ",
  "item.minecraft.trial_key": "試練の鍵",
  "item.minecraft.trident": "トライデント",
  "item.minecraft.tropical_fish": "熱帯魚",
  "item.minecraft.tropical_fish_bucket": "熱帯魚入りバケツ",
  "item.minecraft.tropical_fish_spawn_egg": "熱帯魚のスポーンエッグ",
  "item.minecraft.turtle_helmet": "カメの甲羅",
  "item.minecraft.turtle_scute": "カメのウロコ",
  "item.minecraft.turtle_spawn_egg": "カメのスポーンエッグ",
  "item.minecraft.vex_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.vex_armor_trim_smithing_template.new": "ヴェックス風の装飾",
  "item.minecraft.vex_spawn_egg": "ヴェックスのスポーンエッグ",
  "item.minecraft.villager_spawn_egg": "村人のスポーンエッグ",
  "item.minecraft.vindicator_spawn_egg": "ヴィンディケーターのスポーンエッグ",
  "item.minecraft.wandering_trader_spawn_egg": "行商人のスポーンエッグ",
  "item.minecraft.ward_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.ward_armor_trim_smithing_template.new": "監獄風の装飾",
  "item.minecraft.warden_spawn_egg": "ウォーデンのスポーンエッグ",
  "item.minecraft.warped_fungus_on_a_stick": "歪んだキノコ付きの棒",
  "item.minecraft.water_bucket": "水入りバケツ",
  "item.minecraft.wayfinder_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.wayfinder_armor_trim_smithing_template.new": "先駆者風の装飾",
  "item.minecraft.wheat": "小麦",
  "item.minecraft.wheat_seeds": "小麦の種",
  "item.minecraft.white_bundle": "白色のバンドル",
  "item.minecraft.white_dye": "白色の染料",
  "item.minecraft.white_harness": "白色のハーネス",
  "item.minecraft.wild_armor_trim_smithing_template": "鍛冶型",
  "item.minecraft.wild_armor_trim_smithing_template.new": "大自然風の装飾",
  "item.minecraft.wind_charge": "ウィンドチャージ",
  "item.minecraft.witch_spawn_egg": "ウィッチのスポーンエッグ",
  "item.minecraft.wither_skeleton_spawn_egg": "ウィザースケルトンのスポーンエッグ",
  "item.minecraft.wither_spawn_egg": "ウィザーのスポーンエッグ",
  "item.minecraft.wolf_armor": "オオカミの鎧",
  "item.minecraft.wolf_spawn_egg": "オオカミのスポーンエッグ",
  "item.minecraft.wooden_axe": "木の斧",
  "item.minecraft.wooden_hoe": "木のクワ",
  "item.minecraft.wooden_pickaxe": "木のツルハシ",
  "item.minecraft.wooden_shovel": "木のシャベル",
  "item.minecraft.wooden_spear": "木の槍",
  "item.minecraft.wooden_sword": "木の剣",
  "item.minecraft.writable_book": "本と羽根ペン",
  "item.minecraft.written_book": "記入済みの本",
  "item.minecraft.yellow_bundle": "黄色のバンドル",
  "item.minecraft.yellow_dye": "黄色の染料",
  "item.minecraft.yellow_harness": "黄色のハーネス",
  "item.minecraft.zoglin_spawn_egg": "ゾグリンのスポーンエッグ",
  "item.minecraft.zombie_horse_spawn_egg": "ゾンビホースのスポーンエッグ",
  "item.minecraft.zombie_nautilus_spawn_egg": "ゾンビオウムガイのスポーンエッグ",
  "item.minecraft.zombie_spawn_egg": "ゾンビのスポーンエッグ",
  "item.minecraft.zombie_villager_spawn_egg": "村人ゾンビのスポーンエッグ",
  "item.minecraft.zombified_piglin_spawn_egg": "ゾンビピグリンのスポーンエッグ"
}
export const ja_jp = items; 
